// // // // // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // // // // import { useRef, useEffect, useState } from "react";
// // // // // // // // // // // import { User } from "lucide-react";

// // // // // // // // // const testimonials = [
// // // // // // // // //   {
// // // // // // // // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // // // // // // // //     name: "Ayush Mangal Gupta",
// // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // // // // // // // //   },
// // // // // // // // //   {
// // // // // // // // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // // // // // // // //     name: "Vasu Sangal",
// // // // // // // // //     role: "Lawyer / District Court",
// // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // // // // // // // //   },
// // // // // // // // //   {
// // // // // // // // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // // // // // // // //     name: "Ajay Kumar",
// // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // // // // // // // //   },
// // // // // // // // //   {
// // // // // // // // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // // // // // // // //     name: "Krishnam Soni",
// // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#A0E7E5]",
// // // // // // // // //   },
// // // // // // // // //   {
// // // // // // // // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // // // // // // // //     name: "Indresh Goswami",
// // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFE0AC]",
// // // // // // // // //   },
// // // // // // // // //   {
// // // // // // // // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // // // // // // // //     name: "Nitin Shrivastava",
// // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#D1BBFF]",
// // // // // // // // //   },
// // // // // // // // // ];

// // // // // // // // // // // export default function Testimonials() {
// // // // // // // // // // //   const sectionRef = useRef(null);
// // // // // // // // // // //   const [mounted, setMounted] = useState(false);

// // // // // // // // // // //   useEffect(() => {
// // // // // // // // // // //     setMounted(true);
// // // // // // // // // // //   }, []);

// // // // // // // // // // //   // const { scrollYProgress } = useScroll(
// // // // // // // // // // //   //   mounted
// // // // // // // // // // //   //     ? {
// // // // // // // // // // //   //         target: sectionRef,
// // // // // // // // // // //   //         offset: ["start start", "end end"],
// // // // // // // // // // //   //       }
// // // // // // // // // // //   //     : {}
// // // // // // // // // // //   // );


// // // // // // // // // // //   const { scrollYProgress } = useScroll(
// // // // // // // // // // //   mounted
// // // // // // // // // // //     ? {
// // // // // // // // // // //         target: sectionRef,
// // // // // // // // // // //         offset: ["40% start", "end end"],
// // // // // // // // // // //       }
// // // // // // // // // // //     : {}
// // // // // // // // // // // );


// // // // // // // // // // //   const x = useTransform(
// // // // // // // // // // //     scrollYProgress,
// // // // // // // // // // //     [0, 1],
// // // // // // // // // // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // // // // // // // // // //   );

// // // // // // // // // // //   // const opacity = useTransform(
// // // // // // // // // // //   //   scrollYProgress,
// // // // // // // // // // //   //   [0, 0.1, 0.85, 1],
// // // // // // // // // // //   //   [0, 1, 1, 0]
// // // // // // // // // // //   // );

// // // // // // // // // // //   // const scale = useTransform(
// // // // // // // // // // //   //   scrollYProgress,
// // // // // // // // // // //   //   [0, 0.1],
// // // // // // // // // // //   //   [0.96, 1]
// // // // // // // // // // //   // );


// // // // // // // // // // //   const opacity = useTransform(
// // // // // // // // // // //   scrollYProgress,
// // // // // // // // // // //   [0, 0.15, 0.8, 0.9],
// // // // // // // // // // //   [0, 1, 1, 0]
// // // // // // // // // // // );

// // // // // // // // // // // const scale = useTransform(
// // // // // // // // // // //   scrollYProgress,
// // // // // // // // // // //   [0, 0.15],
// // // // // // // // // // //   [0.96, 1]
// // // // // // // // // // // );


// // // // // // // // // // //   return (
// // // // // // // // // // //     <section
// // // // // // // // // // //       ref={sectionRef}
// // // // // // // // // // //       className="relative hidden md:block h-[300vh]"
// // // // // // // // // // //     >
// // // // // // // // // // //       {/* FIXED HEADING + IPAD */}
// // // // // // // // // // //       {/* <motion.div
// // // // // // // // // // //         style={{ opacity, scale }}
// // // // // // // // // // //         className="fixed top-0 left-0 w-full h-screen flex items-center pointer-events-none"
// // // // // // // // // // //       > */}


// // // // // // // // // // //       <motion.div
// // // // // // // // // // //   style={{ opacity, scale }}
// // // // // // // // // // //   className="
// // // // // // // // // // //     fixed top-0 left-0 w-full h-screen
// // // // // // // // // // //     flex items-center pointer-events-none
// // // // // // // // // // //     z-[20]
// // // // // // // // // // //   "
// // // // // // // // // // // >

// // // // // // // // // // //         <div className="mx-auto w-full max-w-7xl px-20 flex items-center justify-between">
          
// // // // // // // // // // //           {/* LEFT HEADING */}
// // // // // // // // // // //           <div className="max-w-md text-left pointer-events-auto">
// // // // // // // // // // //             <h2 className="text-5xl font-bold text-[#141414]">
// // // // // // // // // // //               Testimonials
// // // // // // // // // // //             </h2>
// // // // // // // // // // //             <p className="mt-4 text-lg text-[#141414]">
// // // // // // // // // // //               Trusted By Professionals, Empowering Justice.
// // // // // // // // // // //             </p>
// // // // // // // // // // //           </div>

// // // // // // // // // // //           {/* RIGHT IPAD */}
// // // // // // // // // // //           <div className="relative w-[430px] lg:w-[590px] xl:w-[740px] pointer-events-auto">
// // // // // // // // // // //             <img
// // // // // // // // // // //               src="/ipad-mockup.png"
// // // // // // // // // // //               alt="iPad"
// // // // // // // // // // //               className="w-full h-auto select-none"
// // // // // // // // // // //             />

// // // // // // // // // // //             <div className="absolute top-[17%] left-[26%] w-[48%] h-[65%] bg-white rounded-lg overflow-hidden">
// // // // // // // // // // //               <motion.div className="flex h-full" style={{ x }}>
// // // // // // // // // // //                 {testimonials.map((t, i) => (
// // // // // // // // // // //                   <div
// // // // // // // // // // //                     key={i}
// // // // // // // // // // //                     className="min-w-full h-full flex items-center justify-center px-10"
// // // // // // // // // // //                   >
// // // // // // // // // // //                     <div
// // // // // // // // // // //                       className={`
// // // // // // // // // // //                         w-full max-w-[420px] h-[420px]
// // // // // // // // // // //                         rounded-[22px]
// // // // // // // // // // //                         border border-black
// // // // // // // // // // //                         bg-white
// // // // // // // // // // //                         flex flex-col justify-between
// // // // // // // // // // //                         ${t.borderColor}
// // // // // // // // // // //                       `}
// // // // // // // // // // //                     >
// // // // // // // // // // //                       <div className="px-8 py-10">
// // // // // // // // // // //                         <p className="text-[15px] leading-[1.9] text-[#141414]">
// // // // // // // // // // //                           {t.text}
// // // // // // // // // // //                         </p>
// // // // // // // // // // //                       </div>

// // // // // // // // // // //                       <div className="bg-[#1E1E1E] px-6 py-5 text-white rounded-b-[22px]">
// // // // // // // // // // //                         <p className="font-semibold">{t.name}</p>
// // // // // // // // // // //                         <div className="flex items-center gap-2 text-sm opacity-80 mt-1">
// // // // // // // // // // //                           <User size={14} className="text-purple-400" />
// // // // // // // // // // //                           {t.role}
// // // // // // // // // // //                         </div>
// // // // // // // // // // //                       </div>
// // // // // // // // // // //                     </div>
// // // // // // // // // // //                   </div>
// // // // // // // // // // //                 ))}
// // // // // // // // // // //               </motion.div>
// // // // // // // // // // //             </div>
// // // // // // // // // // //           </div>
// // // // // // // // // // //         </div>
// // // // // // // // // // //       </motion.div>
// // // // // // // // // // //     </section>
// // // // // // // // // // //   );
// // // // // // // // // // // }





















// // // // // // // // // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // // // // // // // // import { useRef, useEffect, useState } from "react";
// // // // // // // // // // // // // // // import { User } from "lucide-react";

// // // // // // // // // // // // // // // const testimonials = [
// // // // // // // // // // // // // // //   {
// // // // // // // // // // // // // // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // // // // // // // // // // // // // //     name: "Ayush Mangal Gupta",
// // // // // // // // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   {
// // // // // // // // // // // // // // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // // // // // // // // // // // // // //     name: "Vasu Sangal",
// // // // // // // // // // // // // // //     role: "Lawyer / District Court",
// // // // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   {
// // // // // // // // // // // // // // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // // // // // // // // // // // // // //     name: "Ajay Kumar",
// // // // // // // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   {
// // // // // // // // // // // // // // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // // // // // // // // // // // // // //     name: "Krishnam Soni",
// // // // // // // // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#A0E7E5]",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   {
// // // // // // // // // // // // // // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // // // // // // // // // // // // // //     name: "Indresh Goswami",
// // // // // // // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFE0AC]",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // //   {
// // // // // // // // // // // // // // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // // // // // // // // // // // // // //     name: "Nitin Shrivastava",
// // // // // // // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#D1BBFF]",
// // // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // // ];

// // // // // // // // // // // // // // // export default function Testimonials() {
// // // // // // // // // // // // // // //   const sectionRef = useRef(null);
// // // // // // // // // // // // // // //   const [mounted, setMounted] = useState(false);

// // // // // // // // // // // // // // //   useEffect(() => {
// // // // // // // // // // // // // // //     setMounted(true);
// // // // // // // // // // // // // // //   }, []);

// // // // // // // // // // // // // // //   const { scrollYProgress } = useScroll(
// // // // // // // // // // // // // // //     mounted
// // // // // // // // // // // // // // //       ? {
// // // // // // // // // // // // // // //           target: sectionRef,
// // // // // // // // // // // // // // //           offset: ["start start", "end end"],
// // // // // // // // // // // // // // //         }
// // // // // // // // // // // // // // //       : {}
// // // // // // // // // // // // // // //   );

// // // // // // // // // // // // // // //   /* ---------------- SLIDE TESTIMONIALS ---------------- */
// // // // // // // // // // // // // // //   const x = useTransform(
// // // // // // // // // // // // // // //     scrollYProgress,
// // // // // // // // // // // // // // //     [0, 1],
// // // // // // // // // // // // // // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // // // // // // // // // // // // // //   );

// // // // // // // // // // // // // // //   /* ---------------- FIXED VISIBILITY (IMPORTANT) ---------------- */
// // // // // // // // // // // // // // //   // const opacity = useTransform(
// // // // // // // // // // // // // // //   //   scrollYProgress,
// // // // // // // // // // // // // // //   //   [0.2, 0.35, 0.85, 1],
// // // // // // // // // // // // // // //   //   [0, 1, 1, 0]
// // // // // // // // // // // // // // //   // );

// // // // // // // // // // // // // // //   const opacity = useTransform(
// // // // // // // // // // // // // // //   scrollYProgress,
// // // // // // // // // // // // // // //   [0.25, 0.35, 0.65, 0.75],
// // // // // // // // // // // // // // //   [0, 1, 1, 0]
// // // // // // // // // // // // // // // );


// // // // // // // // // // // // // // //   const scale = useTransform(
// // // // // // // // // // // // // // //     scrollYProgress,
// // // // // // // // // // // // // // //     [0.2, 0.35],
// // // // // // // // // // // // // // //     [0.96, 1]
// // // // // // // // // // // // // // //   );

// // // // // // // // // // // // // // //   return (
// // // // // // // // // // // // // // //     <section
// // // // // // // // // // // // // // //       ref={sectionRef}
// // // // // // // // // // // // // // //       className="relative hidden md:block h-[300vh]"
// // // // // // // // // // // // // // //     >
// // // // // // // // // // // // // // //       {/* FIXED HEADING + IPAD */}
// // // // // // // // // // // // // // //       {/* <motion.div
// // // // // // // // // // // // // // //         style={{ opacity, scale }}
// // // // // // // // // // // // // // //         className="fixed top-0 left-0 w-full h-screen flex items-center pointer-events-none"
// // // // // // // // // // // // // // //       > */}
// // // // // // // // // // // // // // //       <motion.div
// // // // // // // // // // // // // // //   style={{ opacity, scale }}
// // // // // // // // // // // // // // //   className="fixed top-0 left-0 w-full h-screen flex items-center pointer-events-none z-[10]"
// // // // // // // // // // // // // // // >

// // // // // // // // // // // // // // //         <div className="mx-auto w-full max-w-7xl px-20 flex items-center justify-between">
          
// // // // // // // // // // // // // // //           {/* LEFT HEADING */}
// // // // // // // // // // // // // // //           <div className="max-w-md text-left pointer-events-auto">
// // // // // // // // // // // // // // //             <h2 className="text-5xl font-bold text-[#141414]">
// // // // // // // // // // // // // // //               Testimonials
// // // // // // // // // // // // // // //             </h2>
// // // // // // // // // // // // // // //             <p className="mt-4 text-lg text-[#141414]">
// // // // // // // // // // // // // // //               Trusted By Professionals, Empowering Justice.
// // // // // // // // // // // // // // //             </p>
// // // // // // // // // // // // // // //           </div>

// // // // // // // // // // // // // // //           {/* RIGHT IPAD */}
// // // // // // // // // // // // // // //           <div className="relative w-[430px] lg:w-[590px] xl:w-[740px] pointer-events-auto">
// // // // // // // // // // // // // // //             <img
// // // // // // // // // // // // // // //               src="/ipad-mockup.png"
// // // // // // // // // // // // // // //               alt="iPad"
// // // // // // // // // // // // // // //               className="w-full h-auto select-none"
// // // // // // // // // // // // // // //             />

// // // // // // // // // // // // // // //             <div className="absolute top-[17%] left-[26%] w-[48%] h-[65%] bg-white rounded-lg overflow-hidden">
// // // // // // // // // // // // // // //               <motion.div className="flex h-full" style={{ x }}>
// // // // // // // // // // // // // // //                 {testimonials.map((t, i) => (
// // // // // // // // // // // // // // //                   <div
// // // // // // // // // // // // // // //                     key={i}
// // // // // // // // // // // // // // //                     className="min-w-full h-full flex items-center justify-center px-10"
// // // // // // // // // // // // // // //                   >
// // // // // // // // // // // // // // //                     <div
// // // // // // // // // // // // // // //                       className={`
// // // // // // // // // // // // // // //                         w-full max-w-[420px] h-[420px]
// // // // // // // // // // // // // // //                         rounded-[22px]
// // // // // // // // // // // // // // //                         border border-black
// // // // // // // // // // // // // // //                         bg-white
// // // // // // // // // // // // // // //                         flex flex-col justify-between
// // // // // // // // // // // // // // //                         ${t.borderColor}
// // // // // // // // // // // // // // //                       `}
// // // // // // // // // // // // // // //                     >
// // // // // // // // // // // // // // //                       <div className="px-8 py-10">
// // // // // // // // // // // // // // //                         <p className="text-[15px] leading-[1.9] text-[#141414]">
// // // // // // // // // // // // // // //                           {t.text}
// // // // // // // // // // // // // // //                         </p>
// // // // // // // // // // // // // // //                       </div>

// // // // // // // // // // // // // // //                       <div className="bg-[#1E1E1E] px-6 py-5 text-white rounded-b-[22px]">
// // // // // // // // // // // // // // //                         <p className="font-semibold">{t.name}</p>
// // // // // // // // // // // // // // //                         <div className="flex items-center gap-2 text-sm opacity-80 mt-1">
// // // // // // // // // // // // // // //                           <User size={14} className="text-purple-400" />
// // // // // // // // // // // // // // //                           {t.role}
// // // // // // // // // // // // // // //                         </div>
// // // // // // // // // // // // // // //                       </div>
// // // // // // // // // // // // // // //                     </div>
// // // // // // // // // // // // // // //                   </div>
// // // // // // // // // // // // // // //                 ))}
// // // // // // // // // // // // // // //               </motion.div>
// // // // // // // // // // // // // // //             </div>
// // // // // // // // // // // // // // //           </div>
// // // // // // // // // // // // // // //         </div>
// // // // // // // // // // // // // // //       </motion.div>
// // // // // // // // // // // // // // //     </section>
// // // // // // // // // // // // // // //   );
// // // // // // // // // // // // // // // }





















// // // // // // // // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // // // // // // // import { useRef, useEffect, useState } from "react";
// // // // // // // // // // // // // // import { User } from "lucide-react";

// // // // // // // // // // // // // // const testimonials = [
// // // // // // // // // // // // // //   {
// // // // // // // // // // // // // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // // // // // // // // // // // // //     name: "Ayush Mangal Gupta",
// // // // // // // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // // // // // // // // // // // // //   },
// // // // // // // // // // // // // //   {
// // // // // // // // // // // // // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // // // // // // // // // // // // //     name: "Vasu Sangal",
// // // // // // // // // // // // // //     role: "Lawyer / District Court",
// // // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // // // // // // // // // // // // //   },
// // // // // // // // // // // // // //   {
// // // // // // // // // // // // // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // // // // // // // // // // // // //     name: "Ajay Kumar",
// // // // // // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // // // // // // // // // // // // //   },
// // // // // // // // // // // // // //   {
// // // // // // // // // // // // // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // // // // // // // // // // // // //     name: "Krishnam Soni",
// // // // // // // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#A0E7E5]",
// // // // // // // // // // // // // //   },
// // // // // // // // // // // // // //   {
// // // // // // // // // // // // // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // // // // // // // // // // // // //     name: "Indresh Goswami",
// // // // // // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFE0AC]",
// // // // // // // // // // // // // //   },
// // // // // // // // // // // // // //   {
// // // // // // // // // // // // // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // // // // // // // // // // // // //     name: "Nitin Shrivastava",
// // // // // // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#D1BBFF]",
// // // // // // // // // // // // // //   },
// // // // // // // // // // // // // // ];

// // // // // // // // // // // // // // export default function Testimonials() {
// // // // // // // // // // // // // //   const sectionRef = useRef(null);
// // // // // // // // // // // // // //   const [mounted, setMounted] = useState(false);

// // // // // // // // // // // // // //   useEffect(() => {
// // // // // // // // // // // // // //     setMounted(true);
// // // // // // // // // // // // // //   }, []);

// // // // // // // // // // // // // //   const { scrollYProgress } = useScroll(
// // // // // // // // // // // // // //     mounted
// // // // // // // // // // // // // //       ? {
// // // // // // // // // // // // // //           target: sectionRef,
// // // // // // // // // // // // // //           offset: ["start start", "end end"],
// // // // // // // // // // // // // //         }
// // // // // // // // // // // // // //       : {}
// // // // // // // // // // // // // //   );

// // // // // // // // // // // // // //   /* ---------------- SLIDE CONTENT ---------------- */
// // // // // // // // // // // // // //   const x = useTransform(
// // // // // // // // // // // // // //     scrollYProgress,
// // // // // // // // // // // // // //     [0, 1],
// // // // // // // // // // // // // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // // // // // // // // // // // // //   );

// // // // // // // // // // // // // //   /* ---------------- VISIBILITY CONTROL (FIXED) ---------------- */
// // // // // // // // // // // // // //   const opacity = useTransform(
// // // // // // // // // // // // // //     scrollYProgress,
// // // // // // // // // // // // // //     [0.25, 0.35, 0.65, 0.75],
// // // // // // // // // // // // // //     [0, 1, 1, 0]
// // // // // // // // // // // // // //   );

// // // // // // // // // // // // // //   const scale = useTransform(
// // // // // // // // // // // // // //     scrollYProgress,
// // // // // // // // // // // // // //     [0.25, 0.35],
// // // // // // // // // // // // // //     [0.96, 1]
// // // // // // // // // // // // // //   );

// // // // // // // // // // // // // //   return (
// // // // // // // // // // // // // //     <section
// // // // // // // // // // // // // //       ref={sectionRef}
// // // // // // // // // // // // // //       className="relative hidden md:block h-[300vh]"
// // // // // // // // // // // // // //     >
// // // // // // // // // // // // // //       {/* FIXED TESTIMONIAL STAGE */}
// // // // // // // // // // // // // //       <motion.div
// // // // // // // // // // // // // //         style={{ opacity, scale }}
// // // // // // // // // // // // // //         className="
// // // // // // // // // // // // // //           fixed top-0 left-0 w-full h-screen
// // // // // // // // // // // // // //           flex items-center pointer-events-none
// // // // // // // // // // // // // //           z-[10]
// // // // // // // // // // // // // //         "
// // // // // // // // // // // // // //       >
// // // // // // // // // // // // // //         <div className="mx-auto w-full max-w-7xl px-20 flex items-center justify-between">
          
// // // // // // // // // // // // // //           {/* LEFT TEXT */}
// // // // // // // // // // // // // //           <div className="max-w-md text-left pointer-events-auto">
// // // // // // // // // // // // // //             <h2 className="text-5xl font-bold text-[#141414]">
// // // // // // // // // // // // // //               Testimonials
// // // // // // // // // // // // // //             </h2>
// // // // // // // // // // // // // //             <p className="mt-4 text-lg text-[#141414]">
// // // // // // // // // // // // // //               Trusted By Professionals, Empowering Justice.
// // // // // // // // // // // // // //             </p>
// // // // // // // // // // // // // //           </div>

// // // // // // // // // // // // // //           {/* RIGHT IPAD */}
// // // // // // // // // // // // // //           <div className="relative w-[430px] lg:w-[590px] xl:w-[740px] pointer-events-auto">
// // // // // // // // // // // // // //             <img
// // // // // // // // // // // // // //               src="/ipad-mockup.png"
// // // // // // // // // // // // // //               alt="iPad"
// // // // // // // // // // // // // //               className="w-full h-auto select-none"
// // // // // // // // // // // // // //             />

// // // // // // // // // // // // // //             <div className="absolute top-[17%] left-[26%] w-[48%] h-[65%] bg-white rounded-lg overflow-hidden">
// // // // // // // // // // // // // //               <motion.div className="flex h-full" style={{ x }}>
// // // // // // // // // // // // // //                 {testimonials.map((t, i) => (
// // // // // // // // // // // // // //                   <div
// // // // // // // // // // // // // //                     key={i}
// // // // // // // // // // // // // //                     className="min-w-full h-full flex items-center justify-center px-10"
// // // // // // // // // // // // // //                   >
// // // // // // // // // // // // // //                     <div
// // // // // // // // // // // // // //                       className={`
// // // // // // // // // // // // // //                         w-full max-w-[420px] h-[420px]
// // // // // // // // // // // // // //                         rounded-[22px]
// // // // // // // // // // // // // //                         border border-black
// // // // // // // // // // // // // //                         bg-white
// // // // // // // // // // // // // //                         flex flex-col justify-between
// // // // // // // // // // // // // //                         ${t.borderColor}
// // // // // // // // // // // // // //                       `}
// // // // // // // // // // // // // //                     >
// // // // // // // // // // // // // //                       <div className="px-8 py-10">
// // // // // // // // // // // // // //                         <p className="text-[15px] leading-[1.9] text-[#141414]">
// // // // // // // // // // // // // //                           {t.text}
// // // // // // // // // // // // // //                         </p>
// // // // // // // // // // // // // //                       </div>

// // // // // // // // // // // // // //                       <div className="bg-[#1E1E1E] px-6 py-5 text-white rounded-b-[22px]">
// // // // // // // // // // // // // //                         <p className="font-semibold">{t.name}</p>
// // // // // // // // // // // // // //                         <div className="flex items-center gap-2 text-sm opacity-80 mt-1">
// // // // // // // // // // // // // //                           <User size={14} className="text-purple-400" />
// // // // // // // // // // // // // //                           {t.role}
// // // // // // // // // // // // // //                         </div>
// // // // // // // // // // // // // //                       </div>
// // // // // // // // // // // // // //                     </div>
// // // // // // // // // // // // // //                   </div>
// // // // // // // // // // // // // //                 ))}
// // // // // // // // // // // // // //               </motion.div>
// // // // // // // // // // // // // //             </div>
// // // // // // // // // // // // // //           </div>
// // // // // // // // // // // // // //         </div>
// // // // // // // // // // // // // //       </motion.div>

// // // // // // // // // // // // // //       {/* EXIT SPACER — VERY IMPORTANT */}
// // // // // // // // // // // // // //       <div className="h-screen" />
// // // // // // // // // // // // // //     </section>
// // // // // // // // // // // // // //   );
// // // // // // // // // // // // // // }





// // // // // // // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // // // // // // import { useRef, useEffect, useState } from "react";
// // // // // // // // // // // // // import { User } from "lucide-react";

// // // // // // // // // // // // // const testimonials = [
// // // // // // // // // // // // //   {
// // // // // // // // // // // // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // // // // // // // // // // // //     name: "Ayush Mangal Gupta",
// // // // // // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // // // // // // // // // // // //   },
// // // // // // // // // // // // //   {
// // // // // // // // // // // // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // // // // // // // // // // // //     name: "Vasu Sangal",
// // // // // // // // // // // // //     role: "Lawyer / District Court",
// // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // // // // // // // // // // // //   },
// // // // // // // // // // // // //   {
// // // // // // // // // // // // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // // // // // // // // // // // //     name: "Ajay Kumar",
// // // // // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // // // // // // // // // // // //   },
// // // // // // // // // // // // //   {
// // // // // // // // // // // // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // // // // // // // // // // // //     name: "Krishnam Soni",
// // // // // // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#A0E7E5]",
// // // // // // // // // // // // //   },
// // // // // // // // // // // // //   {
// // // // // // // // // // // // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // // // // // // // // // // // //     name: "Indresh Goswami",
// // // // // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFE0AC]",
// // // // // // // // // // // // //   },
// // // // // // // // // // // // //   {
// // // // // // // // // // // // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // // // // // // // // // // // //     name: "Nitin Shrivastava",
// // // // // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#D1BBFF]",
// // // // // // // // // // // // //   },
// // // // // // // // // // // // // ];

// // // // // // // // // // // // // export default function Testimonials() {
// // // // // // // // // // // // //   const sectionRef = useRef(null);
// // // // // // // // // // // // //   const [mounted, setMounted] = useState(false);

// // // // // // // // // // // // //   useEffect(() => {
// // // // // // // // // // // // //     setMounted(true);
// // // // // // // // // // // // //   }, []);

// // // // // // // // // // // // //   const { scrollYProgress } = useScroll(
// // // // // // // // // // // // //     mounted
// // // // // // // // // // // // //       ? {
// // // // // // // // // // // // //           target: sectionRef,
// // // // // // // // // // // // //           offset: ["start start", "end end"],
// // // // // // // // // // // // //         }
// // // // // // // // // // // // //       : {}
// // // // // // // // // // // // //   );

// // // // // // // // // // // // //   /* ---------------- SLIDE CONTENT ---------------- */
// // // // // // // // // // // // //   const x = useTransform(
// // // // // // // // // // // // //     scrollYProgress,
// // // // // // // // // // // // //     [0, 1],
// // // // // // // // // // // // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // // // // // // // // // // // //   );

// // // // // // // // // // // // //   // /* ---------------- VISIBILITY CONTROL ---------------- */
// // // // // // // // // // // // //   // const opacity = useTransform(
// // // // // // // // // // // // //   //   scrollYProgress,
// // // // // // // // // // // // //   //   [0.25, 0.35, 0.65, 0.75],
// // // // // // // // // // // // //   //   [0, 1, 1, 0]
// // // // // // // // // // // // //   // );

// // // // // // // // // // // // //   const opacity = useTransform(
// // // // // // // // // // // // //   scrollYProgress,
// // // // // // // // // // // // //   [0.32, 0.42, 0.62, 0.72],
// // // // // // // // // // // // //   [0, 1, 1, 0]
// // // // // // // // // // // // // );


// // // // // // // // // // // // //   const scale = useTransform(
// // // // // // // // // // // // //     scrollYProgress,
// // // // // // // // // // // // //     [0.25, 0.35],
// // // // // // // // // // // // //     [0.96, 1]
// // // // // // // // // // // // //   );

// // // // // // // // // // // // //   return (
// // // // // // // // // // // // //     <section
// // // // // // // // // // // // //       ref={sectionRef}
// // // // // // // // // // // // //       className="relative hidden md:block h-[300vh]"
// // // // // // // // // // // // //     >
// // // // // // // // // // // // //       {/* FIXED STAGE */}
// // // // // // // // // // // // //       <motion.div
// // // // // // // // // // // // //         style={{ opacity, scale }}
// // // // // // // // // // // // //         className="
// // // // // // // // // // // // //           fixed top-0 left-0 w-full h-screen
// // // // // // // // // // // // //           flex items-center pointer-events-none
// // // // // // // // // // // // //           z-[10]
// // // // // // // // // // // // //         "
// // // // // // // // // // // // //       >
// // // // // // // // // // // // //         <div className="mx-auto w-full max-w-7xl px-20 flex items-center justify-between">
          
// // // // // // // // // // // // //           {/* LEFT TEXT */}
// // // // // // // // // // // // //           <div className="max-w-md text-left pointer-events-auto">
// // // // // // // // // // // // //             <h2 className="text-5xl font-bold text-[#141414]">
// // // // // // // // // // // // //               Testimonials
// // // // // // // // // // // // //             </h2>
// // // // // // // // // // // // //             <p className="mt-4 text-lg text-[#141414]">
// // // // // // // // // // // // //               Trusted By Professionals, Empowering Justice.
// // // // // // // // // // // // //             </p>
// // // // // // // // // // // // //           </div>

// // // // // // // // // // // // //           {/* RIGHT IPAD */}
// // // // // // // // // // // // //           <div className="relative w-[430px] lg:w-[590px] xl:w-[740px] pointer-events-auto">
// // // // // // // // // // // // //             <img
// // // // // // // // // // // // //               src="/ipad-mockup.png"
// // // // // // // // // // // // //               alt="iPad"
// // // // // // // // // // // // //               className="w-full h-auto select-none"
// // // // // // // // // // // // //             />

// // // // // // // // // // // // //             <div className="absolute top-[17%] left-[26%] w-[48%] h-[65%] bg-white rounded-lg overflow-hidden">
// // // // // // // // // // // // //               <motion.div className="flex h-full" style={{ x }}>
// // // // // // // // // // // // //                 {testimonials.map((t, i) => (
// // // // // // // // // // // // //                   <div
// // // // // // // // // // // // //                     key={i}
// // // // // // // // // // // // //                     className="min-w-full h-full flex items-center justify-center px-10"
// // // // // // // // // // // // //                   >
// // // // // // // // // // // // //                     <div
// // // // // // // // // // // // //                       className={`
// // // // // // // // // // // // //                         w-full max-w-[420px] h-[420px]
// // // // // // // // // // // // //                         rounded-[22px]
// // // // // // // // // // // // //                         border border-black
// // // // // // // // // // // // //                         bg-white
// // // // // // // // // // // // //                         flex flex-col justify-between
// // // // // // // // // // // // //                         ${t.borderColor}
// // // // // // // // // // // // //                       `}
// // // // // // // // // // // // //                     >
// // // // // // // // // // // // //                       <div className="px-8 py-10">
// // // // // // // // // // // // //                         <p className="text-[15px] leading-[1.9] text-[#141414]">
// // // // // // // // // // // // //                           {t.text}
// // // // // // // // // // // // //                         </p>
// // // // // // // // // // // // //                       </div>

// // // // // // // // // // // // //                       <div className="bg-[#1E1E1E] px-6 py-5 text-white rounded-b-[22px]">
// // // // // // // // // // // // //                         <p className="font-semibold">{t.name}</p>
// // // // // // // // // // // // //                         <div className="flex items-center gap-2 text-sm opacity-80 mt-1">
// // // // // // // // // // // // //                           <User size={14} className="text-purple-400" />
// // // // // // // // // // // // //                           {t.role}
// // // // // // // // // // // // //                         </div>
// // // // // // // // // // // // //                       </div>
// // // // // // // // // // // // //                     </div>
// // // // // // // // // // // // //                   </div>
// // // // // // // // // // // // //                 ))}
// // // // // // // // // // // // //               </motion.div>
// // // // // // // // // // // // //             </div>
// // // // // // // // // // // // //           </div>
// // // // // // // // // // // // //         </div>
// // // // // // // // // // // // //       </motion.div>

// // // // // // // // // // // // //       {/* EXIT SPACER (CRITICAL) */}
// // // // // // // // // // // // //       <div className="h-screen" />
// // // // // // // // // // // // //     </section>
// // // // // // // // // // // // //   );
// // // // // // // // // // // // // }








// // // // // // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // // // // // import { useRef, useEffect, useState } from "react";
// // // // // // // // // // // // import { User } from "lucide-react";

// // // // // // // // // // // // const testimonials = [...]; // unchanged

// // // // // // // // // // // // export default function Testimonials() {
// // // // // // // // // // // //   const ref = useRef(null);
// // // // // // // // // // // //   const [mounted, setMounted] = useState(false);

// // // // // // // // // // // //   useEffect(() => setMounted(true), []);

// // // // // // // // // // // //   const { scrollYProgress } = useScroll(
// // // // // // // // // // // //     mounted ? { target: ref, offset: ["start start", "end end"] } : {}
// // // // // // // // // // // //   );

// // // // // // // // // // // //   const x = useTransform(scrollYProgress, [0, 1], ["0%", "-500%"]);
// // // // // // // // // // // //   const opacity = useTransform(scrollYProgress, [0.32, 0.42, 0.62, 0.72], [0, 1, 1, 0]);
// // // // // // // // // // // //   const scale = useTransform(scrollYProgress, [0.32, 0.42], [0.96, 1]);

// // // // // // // // // // // //   return (
// // // // // // // // // // // //     <section ref={ref} className="relative hidden md:block h-[300vh]">
// // // // // // // // // // // //       <motion.div
// // // // // // // // // // // //         style={{ opacity, scale }}
// // // // // // // // // // // //         className="fixed inset-0 flex items-center z-10"
// // // // // // // // // // // //       >
// // // // // // // // // // // //         <div className="mx-auto max-w-7xl px-20 flex justify-between">
// // // // // // // // // // // //           <div>
// // // // // // // // // // // //             <h2 className="text-[52px] font-semibold tracking-tight">Testimonials</h2>
// // // // // // // // // // // //             <p className="mt-4 text-lg text-black/70">
// // // // // // // // // // // //               Trusted By Professionals, Empowering Justice.
// // // // // // // // // // // //             </p>
// // // // // // // // // // // //           </div>

// // // // // // // // // // // //           <div className="relative w-[700px]">
// // // // // // // // // // // //             <img src="/ipad-mockup.png" />
// // // // // // // // // // // //             <div className="absolute top-[17%] left-[26%] w-[48%] h-[65%] bg-white rounded-xl overflow-hidden">
// // // // // // // // // // // //               <motion.div style={{ x }} className="flex h-full">
// // // // // // // // // // // //                 {testimonials.map((t, i) => (
// // // // // // // // // // // //                   <div key={i} className="min-w-full flex justify-center items-center">
// // // // // // // // // // // //                     <div className="w-[420px] h-[420px] rounded-[28px] shadow-[0_20px_60px_rgba(0,0,0,0.12)] bg-white flex flex-col justify-between">
// // // // // // // // // // // //                       <div className="p-8 text-sm leading-[1.9]">{t.text}</div>
// // // // // // // // // // // //                       <div className="bg-black text-white p-5 rounded-b-[28px]">
// // // // // // // // // // // //                         <p className="font-semibold">{t.name}</p>
// // // // // // // // // // // //                         <div className="flex gap-2 text-sm opacity-80">
// // // // // // // // // // // //                           <User size={14} /> {t.role}
// // // // // // // // // // // //                         </div>
// // // // // // // // // // // //                       </div>
// // // // // // // // // // // //                     </div>
// // // // // // // // // // // //                   </div>
// // // // // // // // // // // //                 ))}
// // // // // // // // // // // //               </motion.div>
// // // // // // // // // // // //             </div>
// // // // // // // // // // // //           </div>
// // // // // // // // // // // //         </div>
// // // // // // // // // // // //       </motion.div>

// // // // // // // // // // // //       <div className="h-screen" />
// // // // // // // // // // // //     </section>
// // // // // // // // // // // //   );









// // // // // // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // // // // // import { useRef, useEffect, useState } from "react";
// // // // // // // // // // // // import { User } from "lucide-react";

// // // // // // // // // // // // const testimonials = [
// // // // // // // // // // // //   {
// // // // // // // // // // // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // // // // // // // // // // //     name: "Ayush Mangal Gupta",
// // // // // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // // // // // // // // // // //   },
// // // // // // // // // // // //   {
// // // // // // // // // // // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // // // // // // // // // // //     name: "Vasu Sangal",
// // // // // // // // // // // //     role: "Lawyer / District Court",
// // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // // // // // // // // // // //   },
// // // // // // // // // // // //   {
// // // // // // // // // // // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // // // // // // // // // // //     name: "Ajay Kumar",
// // // // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // // // // // // // // // // //   },
// // // // // // // // // // // //   {
// // // // // // // // // // // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // // // // // // // // // // //     name: "Krishnam Soni",
// // // // // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#A0E7E5]",
// // // // // // // // // // // //   },
// // // // // // // // // // // //   {
// // // // // // // // // // // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // // // // // // // // // // //     name: "Indresh Goswami",
// // // // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFE0AC]",
// // // // // // // // // // // //   },
// // // // // // // // // // // //   {
// // // // // // // // // // // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // // // // // // // // // // //     name: "Nitin Shrivastava",
// // // // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#D1BBFF]",
// // // // // // // // // // // //   },
// // // // // // // // // // // // ];

// // // // // // // // // // // // export default function Testimonials() {
// // // // // // // // // // // //   const sectionRef = useRef(null);
// // // // // // // // // // // //   const [mounted, setMounted] = useState(false);

// // // // // // // // // // // //   useEffect(() => {
// // // // // // // // // // // //     setMounted(true);
// // // // // // // // // // // //   }, []);

// // // // // // // // // // // //   const { scrollYProgress } = useScroll(
// // // // // // // // // // // //     mounted
// // // // // // // // // // // //       ? {
// // // // // // // // // // // //           target: sectionRef,
// // // // // // // // // // // //           offset: ["start start", "end end"],
// // // // // // // // // // // //         }
// // // // // // // // // // // //       : {}
// // // // // // // // // // // //   );

// // // // // // // // // // // //   /* ---------------- SLIDE CONTENT ---------------- */
// // // // // // // // // // // //   const x = useTransform(
// // // // // // // // // // // //     scrollYProgress,
// // // // // // // // // // // //     [0, 1],
// // // // // // // // // // // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // // // // // // // // // // //   );

// // // // // // // // // // // //   /* ---------------- VISIBILITY CONTROL ---------------- */
// // // // // // // // // // // //   const opacity = useTransform(
// // // // // // // // // // // //     scrollYProgress,
// // // // // // // // // // // //     [0.32, 0.42, 0.62, 0.72],
// // // // // // // // // // // //     [0, 1, 1, 0]
// // // // // // // // // // // //   );

// // // // // // // // // // // //   const scale = useTransform(
// // // // // // // // // // // //     scrollYProgress,
// // // // // // // // // // // //     [0.32, 0.42],
// // // // // // // // // // // //     [0.96, 1]
// // // // // // // // // // // //   );

// // // // // // // // // // // //   return (
// // // // // // // // // // // //     <section
// // // // // // // // // // // //       ref={sectionRef}
// // // // // // // // // // // //       className="relative hidden md:block h-[300vh]"
// // // // // // // // // // // //     >
// // // // // // // // // // // //       {/* FIXED STAGE (ONLY VISIBLE IN THIS SECTION) */}
// // // // // // // // // // // //       <motion.div
// // // // // // // // // // // //         style={{ opacity, scale }}
// // // // // // // // // // // //         className="
// // // // // // // // // // // //           fixed inset-0
// // // // // // // // // // // //           flex items-center
// // // // // // // // // // // //           pointer-events-none
// // // // // // // // // // // //           z-[10]
// // // // // // // // // // // //         "
// // // // // // // // // // // //       >
// // // // // // // // // // // //         <div className="mx-auto w-full max-w-7xl px-20 flex items-center justify-between">
          
// // // // // // // // // // // //           {/* LEFT TEXT */}
// // // // // // // // // // // //           <div className="max-w-md pointer-events-auto">
// // // // // // // // // // // //             <h2 className="text-5xl font-semibold tracking-tight text-[#141414]">
// // // // // // // // // // // //               Testimonials
// // // // // // // // // // // //             </h2>
// // // // // // // // // // // //             <p className="mt-4 text-lg text-[#141414]/70">
// // // // // // // // // // // //               Trusted By Professionals, Empowering Justice.
// // // // // // // // // // // //             </p>
// // // // // // // // // // // //           </div>

// // // // // // // // // // // //           {/* RIGHT IPAD */}
// // // // // // // // // // // //           <div className="relative w-[430px] lg:w-[590px] xl:w-[740px] pointer-events-auto">
// // // // // // // // // // // //             <img
// // // // // // // // // // // //               src="/ipad-mockup.png"
// // // // // // // // // // // //               alt="iPad"
// // // // // // // // // // // //               className="w-full h-auto select-none"
// // // // // // // // // // // //             />

// // // // // // // // // // // //             <div className="absolute top-[17%] left-[26%] w-[48%] h-[65%] bg-white rounded-xl overflow-hidden">
// // // // // // // // // // // //               <motion.div className="flex h-full" style={{ x }}>
// // // // // // // // // // // //                 {testimonials.map((t, i) => (
// // // // // // // // // // // //                   <div
// // // // // // // // // // // //                     key={i}
// // // // // // // // // // // //                     className="min-w-full h-full flex items-center justify-center px-10"
// // // // // // // // // // // //                   >
// // // // // // // // // // // //                     <div
// // // // // // // // // // // //                       className={`
// // // // // // // // // // // //                         w-full max-w-[420px] h-[420px]
// // // // // // // // // // // //                         rounded-[28px]
// // // // // // // // // // // //                         border border-black/10
// // // // // // // // // // // //                         bg-white
// // // // // // // // // // // //                         flex flex-col justify-between
// // // // // // // // // // // //                         shadow-[0_20px_60px_rgba(0,0,0,0.12)]
// // // // // // // // // // // //                         ${t.borderColor}
// // // // // // // // // // // //                       `}
// // // // // // // // // // // //                     >
// // // // // // // // // // // //                       <div className="px-8 py-10">
// // // // // // // // // // // //                         <p className="text-sm leading-[1.9] text-[#141414]/80">
// // // // // // // // // // // //                           {t.text}
// // // // // // // // // // // //                         </p>
// // // // // // // // // // // //                       </div>

// // // // // // // // // // // //                       <div className="bg-[#141414] px-6 py-5 text-white rounded-b-[28px]">
// // // // // // // // // // // //                         <p className="font-semibold">{t.name}</p>
// // // // // // // // // // // //                         <div className="flex items-center gap-2 text-sm opacity-80 mt-1">
// // // // // // // // // // // //                           <User size={14} />
// // // // // // // // // // // //                           {t.role}
// // // // // // // // // // // //                         </div>
// // // // // // // // // // // //                       </div>
// // // // // // // // // // // //                     </div>
// // // // // // // // // // // //                   </div>
// // // // // // // // // // // //                 ))}
// // // // // // // // // // // //               </motion.div>
// // // // // // // // // // // //             </div>
// // // // // // // // // // // //           </div>
// // // // // // // // // // // //         </div>
// // // // // // // // // // // //       </motion.div>

// // // // // // // // // // // //       {/* EXIT SPACER — VERY IMPORTANT */}
// // // // // // // // // // // //       <div className="h-screen" />
// // // // // // // // // // // //     </section>
// // // // // // // // // // // //   );
// // // // // // // // // // // // }
























// // // // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // // // import { useRef, useEffect, useState } from "react";
// // // // // // // // // // import { User } from "lucide-react";

// // // // // // // // // // const testimonials = [
// // // // // // // // // //   {
// // // // // // // // // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // // // // // // // // //     name: "Ayush Mangal Gupta",
// // // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // // // // // // // // //   },
// // // // // // // // // //   {
// // // // // // // // // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // // // // // // // // //     name: "Vasu Sangal",
// // // // // // // // // //     role: "Lawyer / District Court",
// // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // // // // // // // // //   },
// // // // // // // // // //   {
// // // // // // // // // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // // // // // // // // //     name: "Ajay Kumar",
// // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // // // // // // // // //   },
// // // // // // // // // //   {
// // // // // // // // // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // // // // // // // // //     name: "Krishnam Soni",
// // // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#A0E7E5]",
// // // // // // // // // //   },
// // // // // // // // // //   {
// // // // // // // // // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // // // // // // // // //     name: "Indresh Goswami",
// // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFE0AC]",
// // // // // // // // // //   },
// // // // // // // // // //   {
// // // // // // // // // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // // // // // // // // //     name: "Nitin Shrivastava",
// // // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#D1BBFF]",
// // // // // // // // // //   },
// // // // // // // // // // ];

// // // // // // // // // // export default function Testimonials() {
// // // // // // // // // //   const sectionRef = useRef(null);
// // // // // // // // // //   const [mounted, setMounted] = useState(false);

// // // // // // // // // //   useEffect(() => {
// // // // // // // // // //     setMounted(true);
// // // // // // // // // //   }, []);

// // // // // // // // // //   /* 🔑 SCROLL IS GATED TO THIS SECTION ONLY */
// // // // // // // // // //   const { scrollYProgress } = useScroll(
// // // // // // // // // //     mounted
// // // // // // // // // //       ? {
// // // // // // // // // //           target: sectionRef,
// // // // // // // // // //           offset: ["start end", "end start"],
// // // // // // // // // //         }
// // // // // // // // // //       : {}
// // // // // // // // // //   );

// // // // // // // // // //   /* SLIDER */
// // // // // // // // // //   const x = useTransform(
// // // // // // // // // //     scrollYProgress,
// // // // // // // // // //     [0, 1],
// // // // // // // // // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // // // // // // // // //   );

// // // // // // // // // //   /* VISIBILITY CONTROL */
// // // // // // // // // //   const opacity = useTransform(
// // // // // // // // // //     scrollYProgress,
// // // // // // // // // //     [0.15, 0.3, 0.7, 0.85],
// // // // // // // // // //     [0, 1, 1, 0]
// // // // // // // // // //   );

// // // // // // // // // //   const scale = useTransform(
// // // // // // // // // //     scrollYProgress,
// // // // // // // // // //     [0.15, 0.3],
// // // // // // // // // //     [0.96, 1]
// // // // // // // // // //   );

// // // // // // // // // //   return (
// // // // // // // // // //     <section
// // // // // // // // // //       ref={sectionRef}
// // // // // // // // // //       className="relative hidden md:block h-[300vh]"
// // // // // // // // // //     >
// // // // // // // // // //       {/* FIXED STAGE */}
// // // // // // // // // //       <motion.div
// // // // // // // // // //         style={{ opacity, scale }}
// // // // // // // // // //         className="
// // // // // // // // // //           fixed top-0 left-0 w-full h-screen
// // // // // // // // // //           flex items-center pointer-events-none
// // // // // // // // // //           z-[30]
// // // // // // // // // //         "
// // // // // // // // // //       >
// // // // // // // // // //         <div className="mx-auto w-full max-w-7xl px-20 flex items-center justify-between">
          
// // // // // // // // // //           {/* LEFT TEXT */}
// // // // // // // // // //           <div className="max-w-md text-left pointer-events-auto">
// // // // // // // // // //             <h2 className="text-5xl font-bold text-[#141414]">
// // // // // // // // // //               Testimonials
// // // // // // // // // //             </h2>
// // // // // // // // // //             <p className="mt-4 text-lg text-[#141414]">
// // // // // // // // // //               Trusted By Professionals, Empowering Justice.
// // // // // // // // // //             </p>
// // // // // // // // // //           </div>

// // // // // // // // // //           {/* RIGHT IPAD */}
// // // // // // // // // //           <div className="relative w-[430px] lg:w-[590px] xl:w-[740px] pointer-events-auto">
// // // // // // // // // //             <img
// // // // // // // // // //               src="/ipad-mockup.png"
// // // // // // // // // //               alt="iPad"
// // // // // // // // // //               className="w-full h-auto select-none"
// // // // // // // // // //             />

// // // // // // // // // //             <div className="absolute top-[17%] left-[26%] w-[48%] h-[65%] bg-white rounded-lg overflow-hidden">
// // // // // // // // // //               <motion.div className="flex h-full" style={{ x }}>
// // // // // // // // // //                 {testimonials.map((t, i) => (
// // // // // // // // // //                   <div
// // // // // // // // // //                     key={i}
// // // // // // // // // //                     className="min-w-full h-full flex items-center justify-center px-10"
// // // // // // // // // //                   >
// // // // // // // // // //                     <div
// // // // // // // // // //                       className={`
// // // // // // // // // //                         w-full max-w-[420px] h-[420px]
// // // // // // // // // //                         rounded-[22px]
// // // // // // // // // //                         border border-black
// // // // // // // // // //                         bg-white
// // // // // // // // // //                         flex flex-col justify-between
// // // // // // // // // //                         ${t.borderColor}
// // // // // // // // // //                       `}
// // // // // // // // // //                     >
// // // // // // // // // //                       <div className="px-8 py-10">
// // // // // // // // // //                         <p className="text-[15px] leading-[1.9] text-[#141414]">
// // // // // // // // // //                           {t.text}
// // // // // // // // // //                         </p>
// // // // // // // // // //                       </div>

// // // // // // // // // //                       <div className="bg-[#1E1E1E] px-6 py-5 text-white rounded-b-[22px]">
// // // // // // // // // //                         <p className="font-semibold">{t.name}</p>
// // // // // // // // // //                         <div className="flex items-center gap-2 text-sm opacity-80 mt-1">
// // // // // // // // // //                           <User size={14} className="text-purple-400" />
// // // // // // // // // //                           {t.role}
// // // // // // // // // //                         </div>
// // // // // // // // // //                       </div>
// // // // // // // // // //                     </div>
// // // // // // // // // //                   </div>
// // // // // // // // // //                 ))}
// // // // // // // // // //               </motion.div>
// // // // // // // // // //             </div>
// // // // // // // // // //           </div>
// // // // // // // // // //         </div>
// // // // // // // // // //       </motion.div>

// // // // // // // // // //       {/* EXIT SPACER — PREVENTS LEAKING */}
// // // // // // // // // //       <div className="h-screen" />
// // // // // // // // // //     </section>
// // // // // // // // // //   );
// // // // // // // // // // }

























// // // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // // import { useRef, useEffect, useState } from "react";
// // // // // // // // // import { User } from "lucide-react";

// // // // // // // // // const testimonials = [
// // // // // // // // //   {
// // // // // // // // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // // // // // // // //     name: "Ayush Mangal Gupta",
// // // // // // // // //     role: "Lawyer / High Court",
// // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // // // // // // // //   },
// // // // // // // // //   {
// // // // // // // // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work.",
// // // // // // // // //     name: "Vasu Sangal",
// // // // // // // // //     role: "Lawyer / District Court",
// // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // // // // // // // //   },
// // // // // // // // //   {
// // // // // // // // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration.",
// // // // // // // // //     name: "Ajay Kumar",
// // // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // // // // // // // //   },
// // // // // // // // // ];

// // // // // // // // // export default function Testimonials() {
// // // // // // // // //   const sectionRef = useRef(null);
// // // // // // // // //   const [mounted, setMounted] = useState(false);

// // // // // // // // //   useEffect(() => setMounted(true), []);

// // // // // // // // //   const { scrollYProgress } = useScroll(
// // // // // // // // //     mounted
// // // // // // // // //       ? {
// // // // // // // // //           target: sectionRef,
// // // // // // // // //           offset: ["start start", "end end"],
// // // // // // // // //         }
// // // // // // // // //       : {}
// // // // // // // // //   );

// // // // // // // // //   /* ---------------- SLIDER ---------------- */
// // // // // // // // //   const x = useTransform(
// // // // // // // // //     scrollYProgress,
// // // // // // // // //     [0, 1],
// // // // // // // // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // // // // // // // //   );

// // // // // // // // //   /* ---------------- VISIBILITY GATE ---------------- */
// // // // // // // // //   const opacity = useTransform(
// // // // // // // // //     scrollYProgress,
// // // // // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // // // // //     [0, 1, 1, 0]
// // // // // // // // //   );

// // // // // // // // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.96, 1]);

// // // // // // // // //   /* 🔒 HARD GATE: hide completely outside section */
// // // // // // // // //   const display = useTransform(scrollYProgress, (v) =>
// // // // // // // // //     v < 0.05 || v > 0.95 ? "none" : "flex"
// // // // // // // // //   );

// // // // // // // // //   return (
// // // // // // // // //     <section
// // // // // // // // //       ref={sectionRef}
// // // // // // // // //       className="relative hidden md:block h-[260vh]"
// // // // // // // // //     >
// // // // // // // // //       <motion.div
// // // // // // // // //         style={{ opacity, scale, display }}
// // // // // // // // //         className="
// // // // // // // // //           fixed inset-0
// // // // // // // // //           z-30
// // // // // // // // //           flex items-center
// // // // // // // // //           pointer-events-none
// // // // // // // // //         "
// // // // // // // // //       >
// // // // // // // // //         <div className="mx-auto w-full max-w-7xl px-20 flex items-center justify-between">
          
// // // // // // // // //           {/* LEFT */}
// // // // // // // // //           <div className="max-w-md pointer-events-auto">
// // // // // // // // //             <h2 className="text-5xl font-bold">Testimonials</h2>
// // // // // // // // //             <p className="mt-4 text-lg">
// // // // // // // // //               Trusted By Professionals, Empowering Justice.
// // // // // // // // //             </p>
// // // // // // // // //           </div>

// // // // // // // // //           {/* RIGHT */}
// // // // // // // // //           <div className="relative w-[520px] pointer-events-auto">
// // // // // // // // //             <img src="/ipad-mockup.png" className="w-full" alt="" />

// // // // // // // // //             <div className="absolute top-[17%] left-[26%] w-[48%] h-[65%] bg-white rounded-lg overflow-hidden">
// // // // // // // // //               <motion.div className="flex h-full" style={{ x }}>
// // // // // // // // //                 {testimonials.map((t, i) => (
// // // // // // // // //                   <div key={i} className="min-w-full flex items-center justify-center px-8">
// // // // // // // // //                     <div
// // // // // // // // //                       className={`w-full h-[420px] rounded-[22px] border border-black bg-white flex flex-col justify-between ${t.borderColor}`}
// // // // // // // // //                     >
// // // // // // // // //                       <div className="px-8 py-10 text-sm leading-[1.9]">
// // // // // // // // //                         {t.text}
// // // // // // // // //                       </div>

// // // // // // // // //                       <div className="bg-[#1E1E1E] px-6 py-5 text-white">
// // // // // // // // //                         <p className="font-semibold">{t.name}</p>
// // // // // // // // //                         <div className="flex items-center gap-2 text-sm opacity-80">
// // // // // // // // //                           <User size={14} />
// // // // // // // // //                           {t.role}
// // // // // // // // //                         </div>
// // // // // // // // //                       </div>
// // // // // // // // //                     </div>
// // // // // // // // //                   </div>
// // // // // // // // //                 ))}
// // // // // // // // //               </motion.div>
// // // // // // // // //             </div>
// // // // // // // // //           </div>
// // // // // // // // //         </div>
// // // // // // // // //       </motion.div>
// // // // // // // // //     </section>
// // // // // // // // //   );
// // // // // // // // // }






// // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // import { useRef, useEffect, useState } from "react";
// // // // // // // // import { User } from "lucide-react";

// // // // // // // // const testimonials = [
// // // // // // // //   {
// // // // // // // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // // // // // // //     name: "Ayush Mangal Gupta",
// // // // // // // //     role: "Lawyer / High Court",
// // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // // // // // // //     name: "Vasu Sangal",
// // // // // // // //     role: "Lawyer / District Court",
// // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // // // // // // //     name: "Ajay Kumar",
// // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // // // // // // //     name: "Krishnam Soni",
// // // // // // // //     role: "Lawyer / High Court",
// // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#A0E7E5]",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // // // // // // //     name: "Indresh Goswami",
// // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFE0AC]",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // // // // // // //     name: "Nitin Shrivastava",
// // // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#D1BBFF]",
// // // // // // // //   },
// // // // // // // // ];

// // // // // // // // export default function Testimonials() {
// // // // // // // //   const sectionRef = useRef(null);
// // // // // // // //   const [mounted, setMounted] = useState(false);

// // // // // // // //   useEffect(() => setMounted(true), []);

// // // // // // // //   const { scrollYProgress } = useScroll(
// // // // // // // //     mounted
// // // // // // // //       ? {
// // // // // // // //           target: sectionRef,
// // // // // // // //           offset: ["start start", "end end"],
// // // // // // // //         }
// // // // // // // //       : {}
// // // // // // // //   );

// // // // // // // //   /* ---------------- SLIDER ---------------- */
// // // // // // // //   const x = useTransform(
// // // // // // // //     scrollYProgress,
// // // // // // // //     [0, 1],
// // // // // // // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // // // // // // //   );

// // // // // // // //   /* ---------------- VISIBILITY GATE ---------------- */
// // // // // // // //   const opacity = useTransform(
// // // // // // // //     scrollYProgress,
// // // // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // // // //     [0, 1, 1, 0]
// // // // // // // //   );

// // // // // // // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.96, 1]);

// // // // // // // //   /* 🔒 HARD GATE */
// // // // // // // //   const display = useTransform(scrollYProgress, (v) =>
// // // // // // // //     v < 0.05 || v > 0.95 ? "none" : "flex"
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <section
// // // // // // // //       ref={sectionRef}
// // // // // // // //       className="relative hidden md:block h-[320vh]"   // ⬆️ increased
// // // // // // // //     >
// // // // // // // //       <motion.div
// // // // // // // //         style={{ opacity, scale, display }}
// // // // // // // //         className="
// // // // // // // //           fixed inset-0
// // // // // // // //           z-30
// // // // // // // //           flex items-center
// // // // // // // //           pointer-events-none
// // // // // // // //         "
// // // // // // // //       >
// // // // // // // //         <div className="mx-auto w-full max-w-7xl px-24 flex items-center justify-between">
          
// // // // // // // //           {/* LEFT */}
// // // // // // // //           <div className="max-w-lg pointer-events-auto">
// // // // // // // //             <h2 className="text-6xl font-bold">Testimonials</h2>
// // // // // // // //             <p className="mt-6 text-xl">
// // // // // // // //               Trusted By Professionals, Empowering Justice.
// // // // // // // //             </p>
// // // // // // // //           </div>

// // // // // // // //           {/* RIGHT */}
// // // // // // // //           <div className="relative w-[640px] pointer-events-auto"> {/* ⬆️ iPad */}
// // // // // // // //             <img src="/ipad-mockup.png" className="w-full" alt="" />

// // // // // // // //             <div className="absolute top-[17%] left-[26%] w-[48%] h-[65%] bg-white rounded-xl overflow-hidden">
// // // // // // // //               <motion.div className="flex h-full" style={{ x }}>
// // // // // // // //                 {testimonials.map((t, i) => (
// // // // // // // //                   <div
// // // // // // // //                     key={i}
// // // // // // // //                     className="min-w-full flex items-center justify-center px-12"
// // // // // // // //                   >
// // // // // // // //                     <div
// // // // // // // //                       className={`
// // // // // // // //                         w-full h-[500px]   /* ⬆️ card height */
// // // // // // // //                         rounded-[26px]
// // // // // // // //                         border border-black
// // // // // // // //                         bg-white
// // // // // // // //                         flex flex-col justify-between
// // // // // // // //                         ${t.borderColor}
// // // // // // // //                       `}
// // // // // // // //                     >
// // // // // // // //                       <div className="px-10 py-12 text-[16px] leading-[1.9]">
// // // // // // // //                         {t.text}
// // // // // // // //                       </div>

// // // // // // // //                       <div className="bg-[#1E1E1E] px-8 py-6 text-white rounded-b-[26px]">
// // // // // // // //                         <p className="font-semibold text-lg">{t.name}</p>
// // // // // // // //                         <div className="flex items-center gap-2 text-base opacity-80">
// // // // // // // //                           <User size={16} />
// // // // // // // //                           {t.role}
// // // // // // // //                         </div>
// // // // // // // //                       </div>
// // // // // // // //                     </div>
// // // // // // // //                   </div>
// // // // // // // //                 ))}
// // // // // // // //               </motion.div>
// // // // // // // //             </div>
// // // // // // // //           </div>
// // // // // // // //         </div>
// // // // // // // //       </motion.div>
// // // // // // // //     </section>
// // // // // // // //   );
// // // // // // // // }































// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef, useEffect, useState } from "react";
// // // // // // // import { User } from "lucide-react";

// // // // // // // const testimonials = [
// // // // // // //   {
// // // // // // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // // // // // //     name: "Ayush Mangal Gupta",
// // // // // // //     role: "Lawyer / High Court",
// // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work.",
// // // // // // //     name: "Vasu Sangal",
// // // // // // //     role: "Lawyer / District Court",
// // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration.",
// // // // // // //     name: "Ajay Kumar",
// // // // // // //     role: "Lawyer / Supreme Court",
// // // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // // // // // //   },
// // // // // // // ];

// // // // // // // export default function Testimonials() {
// // // // // // //   const sectionRef = useRef(null);
// // // // // // //   const [mounted, setMounted] = useState(false);

// // // // // // //   useEffect(() => setMounted(true), []);

// // // // // // //   const { scrollYProgress } = useScroll(
// // // // // // //     mounted
// // // // // // //       ? {
// // // // // // //           target: sectionRef,
// // // // // // //           offset: ["start start", "end end"],
// // // // // // //         }
// // // // // // //       : {}
// // // // // // //   );

// // // // // // //   /* ---------------- SLIDER ---------------- */
// // // // // // //   const x = useTransform(
// // // // // // //     scrollYProgress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   /* ---------------- VISIBILITY GATE ---------------- */
// // // // // // //   const opacity = useTransform(
// // // // // // //     scrollYProgress,
// // // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.96, 1]);

// // // // // // //   const display = useTransform(scrollYProgress, (v) =>
// // // // // // //     v < 0.05 || v > 0.95 ? "none" : "flex"
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={sectionRef}
// // // // // // //       className="relative hidden md:block h-[300vh]"
// // // // // // //     >
// // // // // // //       <motion.div
// // // // // // //         style={{ opacity, scale, display }}
// // // // // // //         className="
// // // // // // //           fixed inset-0
// // // // // // //           z-30
// // // // // // //           flex items-center
// // // // // // //           pointer-events-none
// // // // // // //         "
// // // // // // //       >
// // // // // // //         <div className="mx-auto w-full max-w-7xl px-20 flex items-center justify-between">
          
// // // // // // //           {/* LEFT TEXT */}
// // // // // // //           <div className="max-w-md pointer-events-auto">
// // // // // // //             <h2 className="text-6xl font-bold">Testimonials</h2>
// // // // // // //             <p className="mt-5 text-xl">
// // // // // // //               Trusted By Professionals, Empowering Justice.
// // // // // // //             </p>
// // // // // // //           </div>

// // // // // // //           {/* RIGHT IPAD */}
// // // // // // //           <div className="relative w-[620px] pointer-events-auto">
// // // // // // //             <img src="/ipad-mockup.png" className="w-full" alt="" />

// // // // // // //             <div className="
// // // // // // //               absolute
// // // // // // //               top-[15%]
// // // // // // //               left-[25%]
// // // // // // //               w-[50%]
// // // // // // //               h-[70%]
// // // // // // //               bg-white
// // // // // // //               rounded-xl
// // // // // // //               overflow-hidden
// // // // // // //             ">
// // // // // // //               <motion.div className="flex h-full" style={{ x }}>
// // // // // // //                 {testimonials.map((t, i) => (
// // // // // // //                   <div
// // // // // // //                     key={i}
// // // // // // //                     className="min-w-full flex items-center justify-center px-10"
// // // // // // //                   >
// // // // // // //                     <div
// // // // // // //                       className={`
// // // // // // //                         w-full
// // // // // // //                         h-[520px]
// // // // // // //                         rounded-[26px]
// // // // // // //                         border border-black
// // // // // // //                         bg-white
// // // // // // //                         flex flex-col justify-between
// // // // // // //                         ${t.borderColor}
// // // // // // //                       `}
// // // // // // //                     >
// // // // // // //                       <div className="px-10 py-14 text-[15px] leading-[2]">
// // // // // // //                         {t.text}
// // // // // // //                       </div>

// // // // // // //                       <div className="bg-[#1E1E1E] px-8 py-6 text-white">
// // // // // // //                         <p className="font-semibold text-lg">{t.name}</p>
// // // // // // //                         <div className="flex items-center gap-2 text-sm opacity-80 mt-1">
// // // // // // //                           <User size={14} />
// // // // // // //                           {t.role}
// // // // // // //                         </div>
// // // // // // //                       </div>
// // // // // // //                     </div>
// // // // // // //                   </div>
// // // // // // //                 ))}
// // // // // // //               </motion.div>
// // // // // // //             </div>
// // // // // // //           </div>

// // // // // // //         </div>
// // // // // // //       </motion.div>
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // }















// // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // import { useRef, useEffect, useState } from "react";
// // // // // // import { User } from "lucide-react";

// // // // // // const testimonials = [
// // // // // //   {
// // // // // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // // // // //     name: "Ayush Mangal Gupta",
// // // // // //     role: "Lawyer / High Court",
// // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // // // // //   },
// // // // // //   {
// // // // // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work.",
// // // // // //     name: "Vasu Sangal",
// // // // // //     role: "Lawyer / District Court",
// // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // // // // //   },
// // // // // //   {
// // // // // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration.",
// // // // // //     name: "Ajay Kumar",
// // // // // //     role: "Lawyer / Supreme Court",
// // // // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // // // // //   },
// // // // // // ];

// // // // // // export default function Testimonials() {
// // // // // //   const sectionRef = useRef(null);
// // // // // //   const [mounted, setMounted] = useState(false);

// // // // // //   useEffect(() => setMounted(true), []);

// // // // // //   const { scrollYProgress } = useScroll(
// // // // // //     mounted
// // // // // //       ? { target: sectionRef, offset: ["start start", "end end"] }
// // // // // //       : {}
// // // // // //   );

// // // // // //   const x = useTransform(
// // // // // //     scrollYProgress,
// // // // // //     [0, 1],
// // // // // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // // // // //   );

// // // // // //   const opacity = useTransform(
// // // // // //     scrollYProgress,
// // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // //     [0, 1, 1, 0]
// // // // // //   );

// // // // // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.96, 1]);

// // // // // //   const display = useTransform(scrollYProgress, (v) =>
// // // // // //     v < 0.05 || v > 0.95 ? "none" : "flex"
// // // // // //   );

// // // // // //   return (
// // // // // //     <section ref={sectionRef} className="relative hidden md:block h-[300vh]">
// // // // // //       <motion.div
// // // // // //         style={{ opacity, scale, display }}
// // // // // //         className="fixed inset-0 z-30 flex items-center pointer-events-none"
// // // // // //       >
// // // // // //         <div className="mx-auto w-full max-w-7xl px-20 flex items-center justify-between">
          
// // // // // //           {/* LEFT */}
// // // // // //           <div className="max-w-md pointer-events-auto">
// // // // // //             <h2 className="text-6xl font-bold">Testimonials</h2>
// // // // // //             <p className="mt-5 text-xl">
// // // // // //               Trusted By Professionals, Empowering Justice.
// // // // // //             </p>
// // // // // //           </div>

// // // // // //           {/* RIGHT IPAD */}
// // // // // //           <div className="relative w-[430px] lg:w-[590px] xl:w-[740px] pointer-events-auto">
// // // // // //             <img src="/ipad-mockup.png" className="w-full" alt="" />

// // // // // //             <div className="
// // // // // //               absolute
// // // // // //               top-[17%]
// // // // // //               left-[26%]
// // // // // //               w-[48%]
// // // // // //               h-[65%]
// // // // // //               bg-white
// // // // // //               rounded-lg
// // // // // //               overflow-hidden
// // // // // //             ">
// // // // // //               <motion.div className="flex h-full" style={{ x }}>
// // // // // //                 {testimonials.map((t, i) => (
// // // // // //                   <div key={i} className="min-w-full flex items-center justify-center px-8">
// // // // // //                     <div
// // // // // //                       className={`
// // // // // //                         w-full max-w-[420px] h-[420px]
// // // // // //                         rounded-[22px]
// // // // // //                         border border-black
// // // // // //                         bg-white
// // // // // //                         flex flex-col justify-between
// // // // // //                         ${t.borderColor}
// // // // // //                       `}
// // // // // //                     >
// // // // // //                       <div className="px-8 py-10 text-[15px] leading-[1.9]">
// // // // // //                         {t.text}
// // // // // //                       </div>

// // // // // //                       <div className="bg-[#1E1E1E] px-6 py-5 text-white rounded-b-[22px]">
// // // // // //                         <p className="font-semibold">{t.name}</p>
// // // // // //                         <div className="flex items-center gap-2 text-sm opacity-80 mt-1">
// // // // // //                           <User size={14} />
// // // // // //                           {t.role}
// // // // // //                         </div>
// // // // // //                       </div>
// // // // // //                     </div>
// // // // // //                   </div>
// // // // // //                 ))}
// // // // // //               </motion.div>
// // // // // //             </div>

// // // // // //           </div>
// // // // // //         </div>
// // // // // //       </motion.div>
// // // // // //     </section>
// // // // // //   );
// // // // // // }










// // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // import { useRef, useEffect, useState } from "react";
// // // // // import { User } from "lucide-react";

// // // // // const testimonials = [
// // // // //   {
// // // // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // // // //     name: "Ayush Mangal Gupta",
// // // // //     role: "Lawyer / High Court",
// // // // //     borderColor: "from-[#C9D4FF]/40 to-transparent",
// // // // //   },
// // // // //   {
// // // // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work.",
// // // // //     name: "Vasu Sangal",
// // // // //     role: "Lawyer / District Court",
// // // // //     borderColor: "from-[#B4F8C8]/40 to-transparent",
// // // // //   },
// // // // //   {
// // // // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration.",
// // // // //     name: "Ajay Kumar",
// // // // //     role: "Lawyer / Supreme Court",
// // // // //     borderColor: "from-[#FFD699]/40 to-transparent",
// // // // //   },
// // // // // ];

// // // // // export default function Testimonials() {
// // // // //   const sectionRef = useRef(null);
// // // // //   const [mounted, setMounted] = useState(false);

// // // // //   useEffect(() => setMounted(true), []);

// // // // //   const { scrollYProgress } = useScroll(
// // // // //     mounted ? { target: sectionRef, offset: ["start start", "end end"] } : {}
// // // // //   );

// // // // //   const x = useTransform(
// // // // //     scrollYProgress,
// // // // //     [0, 1],
// // // // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // // // //   );

// // // // //   const opacity = useTransform(
// // // // //     scrollYProgress,
// // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // //     [0, 1, 1, 0]
// // // // //   );

// // // // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.96, 1]);

// // // // //   const display = useTransform(scrollYProgress, (v) =>
// // // // //     v < 0.05 || v > 0.95 ? "none" : "flex"
// // // // //   );

// // // // //   return (
// // // // //     <section ref={sectionRef} className="relative hidden md:block h-[300vh]">
// // // // //       <motion.div
// // // // //         style={{ opacity, scale, display }}
// // // // //         className="fixed inset-0 z-30 flex items-center pointer-events-none"
// // // // //       >
// // // // //         <div className="mx-auto w-full max-w-7xl px-24 flex items-center justify-between gap-20">

// // // // //           {/* LEFT CONTENT */}
// // // // //           <motion.div
// // // // //             initial={{ opacity: 0, y: 40 }}
// // // // //             animate={{ opacity: 1, y: 0 }}
// // // // //             transition={{ duration: 0.6 }}
// // // // //             className="max-w-md pointer-events-auto"
// // // // //           >
// // // // //             <h2 className="text-6xl font-extrabold tracking-tight text-neutral-900">
// // // // //               What Professionals Say
// // // // //             </h2>
// // // // //             <p className="mt-6 text-xl text-neutral-600 leading-relaxed">
// // // // //               Trusted by legal experts across courts.  
// // // // //               Built to empower justice with precision.
// // // // //             </p>
// // // // //           </motion.div>

// // // // //           {/* RIGHT IPAD */}
// // // // //           <div className="relative w-[440px] lg:w-[600px] xl:w-[760px] pointer-events-auto">
// // // // //             <img
// // // // //               src="/ipad-mockup.png"
// // // // //               className="w-full drop-shadow-[0_40px_80px_rgba(0,0,0,0.25)]"
// // // // //               alt=""
// // // // //             />

// // // // //             {/* SCREEN */}
// // // // //             <div
// // // // //               className="
// // // // //                 absolute
// // // // //                 top-[16%]
// // // // //                 left-[25.5%]
// // // // //                 w-[49%]
// // // // //                 h-[66%]
// // // // //                 rounded-2xl
// // // // //                 overflow-hidden
// // // // //                 bg-white/70
// // // // //                 backdrop-blur-xl
// // // // //                 border border-white/50
// // // // //               "
// // // // //             >
// // // // //               <motion.div className="flex h-full" style={{ x }}>
// // // // //                 {testimonials.map((t, i) => (
// // // // //                   <div
// // // // //                     key={i}
// // // // //                     className="min-w-full flex items-center justify-center px-8"
// // // // //                   >
// // // // //                     <motion.div
// // // // //                       initial={{ opacity: 0, y: 20 }}
// // // // //                       animate={{ opacity: 1, y: 0 }}
// // // // //                       transition={{ duration: 0.5 }}
// // // // //                       className={`
// // // // //                         relative
// // // // //                         w-full
// // // // //                         h-[430px]
// // // // //                         rounded-[26px]
// // // // //                         bg-white
// // // // //                         flex flex-col justify-between
// // // // //                         shadow-[0_25px_60px_rgba(0,0,0,0.12)]
// // // // //                         overflow-hidden
// // // // //                       `}
// // // // //                     >
// // // // //                       {/* GRADIENT BORDER */}
// // // // //                       <div
// // // // //                         className={`absolute inset-0 bg-gradient-to-b ${t.borderColor} pointer-events-none`}
// // // // //                       />

// // // // //                       {/* TEXT */}
// // // // //                       <div className="relative px-10 py-12 text-[15.5px] leading-[2] text-neutral-800">
// // // // //                         “{t.text}”
// // // // //                       </div>

// // // // //                       {/* FOOTER */}
// // // // //                       <div className="relative bg-neutral-900 px-8 py-6 text-white">
// // // // //                         <p className="font-semibold text-lg">{t.name}</p>
// // // // //                         <div className="flex items-center gap-2 text-sm opacity-80 mt-1">
// // // // //                           <User size={14} />
// // // // //                           {t.role}
// // // // //                         </div>
// // // // //                       </div>
// // // // //                     </motion.div>
// // // // //                   </div>
// // // // //                 ))}
// // // // //               </motion.div>
// // // // //             </div>
// // // // //           </div>

// // // // //         </div>
// // // // //       </motion.div>
// // // // //     </section>
// // // // //   );
// // // // // }






// // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // import { useRef, useEffect, useState } from "react";
// // // // import { User } from "lucide-react";

// // // // const testimonials = [
// // // //   {
// // // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // // //     name: "Ayush Mangal Gupta",
// // // //     role: "Lawyer / High Court",
// // // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // // //   },
// // // //   {
// // // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // // //     name: "Vasu Sangal",
// // // //     role: "Lawyer / District Court",
// // // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // // //   },
// // // //   {
// // // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // // //     name: "Ajay Kumar",
// // // //     role: "Lawyer / Supreme Court",
// // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // // //   },
// // // //   {
// // // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // // //     name: "Krishnam Soni",
// // // //     role: "Lawyer / High Court",
// // // //     borderColor: "shadow-[inset_0px_4px_22px_#A0E7E5]",
// // // //   },
// // // //   {
// // // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // // //     name: "Indresh Goswami",
// // // //     role: "Lawyer / Supreme Court",
// // // //     borderColor: "shadow-[inset_0px_4px_22px_#FFE0AC]",
// // // //   },
// // // //   {
// // // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // // //     name: "Nitin Shrivastava",
// // // //     role: "Lawyer / Supreme Court",
// // // //     borderColor: "shadow-[inset_0px_4px_22px_#D1BBFF]",
// // // //   },
// // // // ];

// // // // export default function Testimonials() {
// // // //   const sectionRef = useRef(null);
// // // //   const [mounted, setMounted] = useState(false);

// // // //   useEffect(() => setMounted(true), []);

// // // //   const { scrollYProgress } = useScroll(
// // // //     mounted ? { target: sectionRef, offset: ["start start", "end end"] } : {}
// // // //   );

// // // //   const x = useTransform(
// // // //     scrollYProgress,
// // // //     [0, 1],
// // // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // // //   );

// // // //   const opacity = useTransform(
// // // //     scrollYProgress,
// // // //     [0.05, 0.15, 0.85, 0.95],
// // // //     [0, 1, 1, 0]
// // // //   );

// // // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.96, 1]);

// // // //   const display = useTransform(scrollYProgress, (v) =>
// // // //     v < 0.05 || v > 0.95 ? "none" : "flex"
// // // //   );

// // // //   return (
// // // //     <section ref={sectionRef} className="relative hidden md:block h-[300vh]">
// // // //       <motion.div
// // // //         style={{ opacity, scale, display }}
// // // //         className="fixed inset-0 z-30 flex items-center pointer-events-none"
// // // //       >
// // // //         <div className="mx-auto w-full max-w-7xl px-24">

// // // //           {/* HEADER */}
// // // //           <div className="mb-24 max-w-2xl pointer-events-auto">
// // // //             <h2 className="text-6xl font-extrabold tracking-tight text-neutral-900">
// // // //               Trusted by Legal Professionals
// // // //             </h2>
// // // //             <p className="mt-6 text-xl text-neutral-600 leading-relaxed">
// // // //               Real stories from lawyers using Jurident to simplify practice,
// // // //               improve collaboration, and stay ahead.
// // // //             </p>
// // // //           </div>

// // // //           {/* SLIDER */}
// // // //           <div className="relative overflow-hidden pointer-events-auto">
// // // //             <motion.div
// // // //               className="flex gap-20"
// // // //               style={{ x }}
// // // //             >
// // // //               {testimonials.map((t, i) => (
// // // //                 <motion.div
// // // //                   key={i}
// // // //                   className="min-w-[70%]"
// // // //                   initial={{ opacity: 0, y: 40 }}
// // // //                   animate={{ opacity: 1, y: 0 }}
// // // //                   transition={{ duration: 0.6 }}
// // // //                 >
// // // //                   <div
// // // //                     className="
// // // //                       relative
// // // //                       h-[360px]
// // // //                       rounded-[32px]
// // // //                       bg-white
// // // //                       shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // //                       p-14
// // // //                       flex flex-col justify-between
// // // //                       overflow-hidden
// // // //                     "
// // // //                   >
// // // //                     {/* ACCENT GRADIENT */}
// // // //                     <div
// // // //                       className={`absolute inset-0 bg-gradient-to-br ${t.accent}`}
// // // //                     />

// // // //                     {/* QUOTE */}
// // // //                     <p className="relative text-[22px] leading-[1.9] text-neutral-800 max-w-3xl">
// // // //                       “{t.text}”
// // // //                     </p>

// // // //                     {/* FOOTER */}
// // // //                     <div className="relative flex items-center gap-4 pt-10">
// // // //                       <div className="h-12 w-12 rounded-full bg-neutral-900 flex items-center justify-center text-white">
// // // //                         <User size={18} />
// // // //                       </div>
// // // //                       <div>
// // // //                         <p className="text-lg font-semibold text-neutral-900">
// // // //                           {t.name}
// // // //                         </p>
// // // //                         <p className="text-sm text-neutral-500">
// // // //                           {t.role}
// // // //                         </p>
// // // //                       </div>
// // // //                     </div>
// // // //                   </div>
// // // //                 </motion.div>
// // // //               ))}
// // // //             </motion.div>
// // // //           </div>

// // // //         </div>
// // // //       </motion.div>
// // // //     </section>
// // // //   );
// // // // }






// // // import { motion, useScroll, useTransform } from "framer-motion";
// // // import { useRef, useEffect, useState } from "react";
// // // import { User } from "lucide-react";

// // // const testimonials = [
// // //   {
// // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // //     name: "Ayush Mangal Gupta",
// // //     role: "Lawyer / High Court",
// // //     glow: "from-indigo-400/20 via-indigo-300/10 to-transparent",
// // //   },
// // //   {
// // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // //     name: "Vasu Sangal",
// // //     role: "Lawyer / District Court",
// // //     glow: "from-emerald-400/20 via-emerald-300/10 to-transparent",
// // //   },
// // //   {
// // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // //     name: "Ajay Kumar",
// // //     role: "Lawyer / Supreme Court",
// // //     glow: "from-amber-400/20 via-amber-300/10 to-transparent",
// // //   },
// // //   {
// // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // //     name: "Krishnam Soni",
// // //     role: "Lawyer / High Court",
// // //     glow: "from-cyan-400/20 via-cyan-300/10 to-transparent",
// // //   },
// // //   {
// // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // //     name: "Indresh Goswami",
// // //     role: "Lawyer / Supreme Court",
// // //     glow: "from-orange-400/20 via-orange-300/10 to-transparent",
// // //   },
// // //   {
// // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // //     name: "Nitin Shrivastava",
// // //     role: "Lawyer / Supreme Court",
// // //     glow: "from-purple-400/20 via-purple-300/10 to-transparent",
// // //   },
// // // ];

// // // export default function Testimonials() {
// // //   const sectionRef = useRef(null);
// // //   const [mounted, setMounted] = useState(false);

// // //   useEffect(() => setMounted(true), []);

// // //   const { scrollYProgress } = useScroll(
// // //     mounted ? { target: sectionRef, offset: ["start start", "end end"] } : {}
// // //   );

// // //   const x = useTransform(
// // //     scrollYProgress,
// // //     [0, 1],
// // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // //   );

// // //   const opacity = useTransform(
// // //     scrollYProgress,
// // //     [0.05, 0.15, 0.85, 0.95],
// // //     [0, 1, 1, 0]
// // //   );

// // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.96, 1]);

// // //   const display = useTransform(scrollYProgress, (v) =>
// // //     v < 0.05 || v > 0.95 ? "none" : "flex"
// // //   );

// // //   return (
// // //     <section ref={sectionRef} className="relative hidden md:block h-[300vh]">
// // //       <motion.div
// // //         style={{ opacity, scale, display }}
// // //         className="fixed inset-0 z-30 flex items-center pointer-events-none"
// // //       >
// // //         <div className="mx-auto w-full max-w-7xl px-24">

// // //           {/* HEADER */}
// // //           <div className="mb-28 max-w-3xl pointer-events-auto">
// // //             <h2 className="text-[72px] leading-[1.05] font-extrabold tracking-tight text-neutral-900">
// // //               Voices of Trust
// // //             </h2>
// // //             <p className="mt-8 text-2xl text-neutral-600 leading-relaxed">
// // //               Lawyers across courts trust Jurident to streamline workflows,
// // //               enhance collaboration, and deliver excellence.
// // //             </p>
// // //           </div>

// // //           {/* SLIDER */}
// // //           <div className="relative overflow-hidden pointer-events-auto">
// // //             <motion.div className="flex gap-24" style={{ x }}>
// // //               {testimonials.map((t, i) => (
// // //                 <motion.div
// // //                   key={i}
// // //                   className="min-w-[72%]"
// // //                   initial={{ opacity: 0, y: 60 }}
// // //                   animate={{ opacity: 1, y: 0 }}
// // //                   transition={{ duration: 0.7, ease: "easeOut" }}
// // //                 >
// // //                   <div className="relative rounded-[36px] bg-white/80 backdrop-blur-xl shadow-[0_60px_160px_rgba(0,0,0,0.15)] p-16 overflow-hidden">

// // //                     {/* GLOW */}
// // //                     <div
// // //                       className={`absolute inset-0 bg-gradient-to-br ${t.glow}`}
// // //                     />

// // //                     {/* QUOTE MARK */}
// // //                     <div className="absolute top-10 right-14 text-[120px] font-serif text-neutral-200/60">
// // //                       “
// // //                     </div>

// // //                     {/* TEXT */}
// // //                     <p className="relative text-[24px] leading-[2] text-neutral-800 max-w-4xl">
// // //                       {t.text}
// // //                     </p>

// // //                     {/* FOOTER */}
// // //                     <div className="relative mt-14 flex items-center gap-5">
// // //                       <div className="h-14 w-14 rounded-full bg-neutral-900 flex items-center justify-center text-white shadow-lg">
// // //                         <User size={20} />
// // //                       </div>
// // //                       <div>
// // //                         <p className="text-xl font-semibold text-neutral-900">
// // //                           {t.name}
// // //                         </p>
// // //                         <p className="text-sm uppercase tracking-wide text-neutral-500">
// // //                           {t.role}
// // //                         </p>
// // //                       </div>
// // //                     </div>

// // //                   </div>
// // //                 </motion.div>
// // //               ))}
// // //             </motion.div>
// // //           </div>

// // //         </div>
// // //       </motion.div>
// // //     </section>
// // //   );
// // // }


















// // // import { motion, useScroll, useTransform } from "framer-motion";
// // // import { useRef, useEffect, useState } from "react";
// // // import { User } from "lucide-react";

// // // const testimonials = [
// // //   {
// // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // //     name: "Ayush Mangal Gupta",
// // //     role: "Lawyer / High Court",
// // //     accent: "from-indigo-500 to-violet-500",
// // //   },
// // //   {
// // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature ensures nothing falls through the cracks.",
// // //     name: "Vasu Sangal",
// // //     role: "Lawyer / District Court",
// // //     accent: "from-emerald-500 to-teal-500",
// // //   },
// // //   {
// // //     text: "The team assistance feature greatly enhances collaboration. Sharing case details and updates is effortless and keeps everyone aligned.",
// // //     name: "Ajay Kumar",
// // //     role: "Lawyer / Supreme Court",
// // //     accent: "from-amber-500 to-orange-500",
// // //   },
// // // ];

// // // export default function Testimonials() {
// // //   const sectionRef = useRef(null);
// // //   const [mounted, setMounted] = useState(false);

// // //   useEffect(() => setMounted(true), []);

// // //   const { scrollYProgress } = useScroll(
// // //     mounted ? { target: sectionRef, offset: ["start start", "end end"] } : {}
// // //   );

// // //   const x = useTransform(
// // //     scrollYProgress,
// // //     [0, 1],
// // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // //   );

// // //   const opacity = useTransform(
// // //     scrollYProgress,
// // //     [0.05, 0.15, 0.85, 0.95],
// // //     [0, 1, 1, 0]
// // //   );

// // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.96, 1]);

// // //   const display = useTransform(scrollYProgress, (v) =>
// // //     v < 0.05 || v > 0.95 ? "none" : "flex"
// // //   );

// // //   return (
// // //     <section
// // //       ref={sectionRef}
// // //       className="relative hidden md:block h-[300vh] bg-[#0B0B0F]"
// // //     >
// // //       <motion.div
// // //         style={{ opacity, scale, display }}
// // //         className="fixed inset-0 z-30 flex items-center pointer-events-none"
// // //       >
// // //         <div className="mx-auto w-full max-w-6xl px-20">

// // //           {/* HEADER */}
// // //           <div className="mb-24 pointer-events-auto">
// // //             <h2 className="text-7xl font-extrabold tracking-tight text-white">
// // //               What Legal Experts Say
// // //             </h2>
// // //             <p className="mt-6 text-xl text-neutral-400 max-w-2xl">
// // //               Honest feedback from professionals who rely on Jurident every day
// // //               to manage cases, teams, and deadlines.
// // //             </p>
// // //           </div>

// // //           {/* SLIDER */}
// // //           <div className="relative overflow-hidden pointer-events-auto">
// // //             <motion.div className="flex gap-20" style={{ x }}>
// // //               {testimonials.map((t, i) => (
// // //                 <div key={i} className="min-w-full">
// // //                   <div className="relative rounded-[32px] bg-[#12121A] border border-white/10 p-16">

// // //                     {/* ACCENT BAR */}
// // //                     <div
// // //                       className={`absolute left-0 top-0 h-full w-[6px] bg-gradient-to-b ${t.accent}`}
// // //                     />

// // //                     {/* QUOTE */}
// // //                     <p className="text-[26px] leading-[1.9] text-neutral-200 max-w-4xl">
// // //                       {t.text}
// // //                     </p>

// // //                     {/* DIVIDER */}
// // //                     <div className="my-12 h-px w-full bg-white/10" />

// // //                     {/* AUTHOR */}
// // //                     <div className="flex items-center gap-5">
// // //                       <div className="h-14 w-14 rounded-full bg-gradient-to-br from-white/10 to-white/5 flex items-center justify-center text-white">
// // //                         <User size={20} />
// // //                       </div>

// // //                       <div>
// // //                         <p className="text-lg font-semibold text-white">
// // //                           {t.name}
// // //                         </p>
// // //                         <p className="text-sm text-neutral-400">
// // //                           {t.role}
// // //                         </p>
// // //                       </div>
// // //                     </div>

// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </motion.div>
// // //           </div>

// // //         </div>
// // //       </motion.div>
// // //     </section>
// // //   );
// // // }


















// // // import { motion, useScroll, useTransform } from "framer-motion";
// // // import { useRef, useEffect, useState } from "react";
// // // import { User } from "lucide-react";

// // // const testimonials = [
// // //   {
// // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // //     name: "Ayush Mangal Gupta",
// // //     role: "Lawyer / High Court",
// // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // //   },
// // //   {
// // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // //     name: "Vasu Sangal",
// // //     role: "Lawyer / District Court",
// // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // //   },
// // //   {
// // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // //     name: "Ajay Kumar",
// // //     role: "Lawyer / Supreme Court",
// // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // //   },
// // //   {
// // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // //     name: "Krishnam Soni",
// // //     role: "Lawyer / High Court",
// // //     borderColor: "shadow-[inset_0px_4px_22px_#A0E7E5]",
// // //   },
// // //   {
// // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // //     name: "Indresh Goswami",
// // //     role: "Lawyer / Supreme Court",
// // //     borderColor: "shadow-[inset_0px_4px_22px_#FFE0AC]",
// // //   },
// // //   {
// // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // //     name: "Nitin Shrivastava",
// // //     role: "Lawyer / Supreme Court",
// // //     borderColor: "shadow-[inset_0px_4px_22px_#D1BBFF]",
// // //   },
// // // ];


// // // export default function Testimonials() {
// // //   const sectionRef = useRef(null);
// // //   const [mounted, setMounted] = useState(false);

// // //   useEffect(() => setMounted(true), []);

// // //   const { scrollYProgress } = useScroll(
// // //     mounted ? { target: sectionRef, offset: ["start start", "end end"] } : {}
// // //   );

// // //   const x = useTransform(
// // //     scrollYProgress,
// // //     [0, 1],
// // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // //   );

// // //   const opacity = useTransform(
// // //     scrollYProgress,
// // //     [0.1, 0.2, 0.8, 0.9],
// // //     [0, 1, 1, 0]
// // //   );

// // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.98, 1]);

// // //   const display = useTransform(scrollYProgress, (v) =>
// // //     v < 0.1 || v > 0.9 ? "none" : "flex"
// // //   );

// // //   return (
// // //     <section
// // //       ref={sectionRef}
// // //       className="relative hidden md:block h-[160vh] bg-[#0B0B0F]"
// // //     >
// // //       <motion.div
// // //         style={{ opacity, scale, display }}
// // //         className="fixed inset-0 z-30 flex items-center pointer-events-none"
// // //       >
// // //         <div className="mx-auto w-full max-w-6xl px-16">

// // //           {/* HEADER */}
// // //           <div className="mb-16 pointer-events-auto">
// // //             <h2 className="text-5xl font-extrabold tracking-tight text-white">
// // //               What Legal Experts Say
// // //             </h2>
// // //             <p className="mt-4 text-lg text-neutral-400 max-w-xl">
// // //               Feedback from professionals using Jurident every day.
// // //             </p>
// // //           </div>

// // //           {/* SLIDER */}
// // //           <div className="relative overflow-hidden pointer-events-auto">
// // //             <motion.div className="flex gap-14" style={{ x }}>
// // //               {testimonials.map((t, i) => (
// // //                 <div key={i} className="min-w-full">
// // //                   <div className="relative rounded-[26px] bg-[#12121A] border border-white/10 p-10">

// // //                     {/* ACCENT BAR */}
// // //                     <div
// // //                       className={`absolute left-0 top-0 h-full w-[5px] bg-gradient-to-b ${t.accent}`}
// // //                     />

// // //                     {/* TEXT */}
// // //                     <p className="text-[20px] leading-[1.7] text-neutral-200 max-w-3xl">
// // //                       {t.text}
// // //                     </p>

// // //                     {/* DIVIDER */}
// // //                     <div className="my-8 h-px w-full bg-white/10" />

// // //                     {/* AUTHOR */}
// // //                     <div className="flex items-center gap-4">
// // //                       <div className="h-12 w-12 rounded-full bg-white/10 flex items-center justify-center text-white">
// // //                         <User size={18} />
// // //                       </div>
// // //                       <div>
// // //                         <p className="text-base font-semibold text-white">
// // //                           {t.name}
// // //                         </p>
// // //                         <p className="text-sm text-neutral-400">
// // //                           {t.role}
// // //                         </p>
// // //                       </div>
// // //                     </div>

// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </motion.div>
// // //           </div>

// // //         </div>
// // //       </motion.div>
// // //     </section>
// // //   );
// // // }













// // // import { motion, useScroll, useTransform } from "framer-motion";
// // // import { useRef, useEffect, useState } from "react";
// // // import { User } from "lucide-react";

// // // const testimonials = [
// // //   {
// // //     text:""
    
// // //   },
// // //   {
// // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // //     name: "Ayush Mangal Gupta",
// // //     role: "Lawyer / High Court",
// // //   },
// // //   {
// // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // //     name: "Vasu Sangal",
// // //     role: "Lawyer / District Court",
// // //   },
// // //   {
// // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // //     name: "Ajay Kumar",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   {
// // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // //     name: "Krishnam Soni",
// // //     role: "Lawyer / High Court",
// // //   },
// // //   {
// // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // //     name: "Indresh Goswami",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   {
// // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // //     name: "Nitin Shrivastava",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   {
// // //     role:""
    
// // //   },
// // // ];

// // // export default function Testimonials() {
// // //   const sectionRef = useRef(null);
// // //   const [mounted, setMounted] = useState(false);

// // //   useEffect(() => setMounted(true), []);

// // //   const { scrollYProgress } = useScroll(
// // //     mounted ? { target: sectionRef, offset: ["start start", "end end"] } : {}
// // //   );

// // //   const x = useTransform(
// // //     scrollYProgress,
// // //     [0, 1],
// // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // //   );

// // //   const opacity = useTransform(
// // //     scrollYProgress,
// // //     [0.1, 0.2, 0.8, 0.9],
// // //     [0, 1, 1, 0]
// // //   );

// // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.98, 1]);

// // //   const display = useTransform(scrollYProgress, (v) =>
// // //     v < 0.1 || v > 0.9 ? "none" : "flex"
// // //   );

// // //   return (
// // //     <section
// // //       ref={sectionRef}
// // //       className="relative hidden md:block h-[160vh] bg-[#0B0B0F]"
// // //     >
// // //       <motion.div
// // //         style={{ opacity, scale, display }}
// // //         className="fixed inset-0 z-30 flex items-center pointer-events-none"
// // //       >
// // //         <div className="mx-auto w-full max-w-6xl px-16">

// // //           {/* HEADER */}
// // //           <div className="mb-14 pointer-events-auto">
// // //             <h2 className="text-5xl font-extrabold text-white">
// // //               What Legal Experts Say
// // //             </h2>
// // //             <p className="mt-4 text-lg text-neutral-400 max-w-xl">
// // //               Feedback from professionals using Jurident every day.
// // //             </p>
// // //           </div>

// // //           {/* SLIDER */}
// // //           <div className="relative overflow-hidden pointer-events-auto">
// // //             <motion.div
// // //               className="flex"
// // //               style={{ x }}
// // //             >
// // //               {testimonials.map((t, i) => (
// // //                 <div
// // //                   key={i}
// // //                   className="min-w-full px-6"
// // //                 >
// // //                   <div className="rounded-[26px] bg-[#12121A] border border-white/10 p-10">

// // //                     {/* TEXT */}
// // //                     <p className="text-[20px] leading-[1.7] text-neutral-200">
// // //                       {t.text}
// // //                     </p>

// // //                     {/* DIVIDER */}
// // //                     <div className="my-8 h-px w-full bg-white/10" />

// // //                     {/* AUTHOR */}
// // //                     <div className="flex items-center gap-4">
// // //                       <div className="h-12 w-12 rounded-full bg-white/10 flex items-center justify-center text-white">
// // //                         <User size={18} />
// // //                       </div>
// // //                       <div>
// // //                         <p className="font-semibold text-white">
// // //                           {t.name}
// // //                         </p>
// // //                         <p className="text-sm text-neutral-400">
// // //                           {t.role}
// // //                         </p>
// // //                       </div>
// // //                     </div>

// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </motion.div>
// // //           </div>

// // //         </div>
// // //       </motion.div>
// // //     </section>
// // //   );
// // // }







// // // import { motion, useScroll, useTransform } from "framer-motion";
// // // import { useRef, useEffect, useState } from "react";
// // // import { User } from "lucide-react";

// // // const testimonials = [
// // //   { text: "" },
// // //   {
// // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // //     name: "Ayush Mangal Gupta",
// // //     role: "Lawyer / High Court",
// // //   },
// // //   {
// // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // //     name: "Vasu Sangal",
// // //     role: "Lawyer / District Court",
// // //   },
// // //   {
// // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // //     name: "Ajay Kumar",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   {
// // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // //     name: "Krishnam Soni",
// // //     role: "Lawyer / High Court",
// // //   },
// // //   {
// // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // //     name: "Indresh Goswami",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   {
// // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // //     name: "Nitin Shrivastava",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   { role: "" },
// // // ];

// // // export default function Testimonials() {
// // //   const sectionRef = useRef(null);
// // //   const [mounted, setMounted] = useState(false);

// // //   useEffect(() => setMounted(true), []);

// // //   const { scrollYProgress } = useScroll(
// // //     mounted ? { target: sectionRef, offset: ["start start", "end end"] } : {}
// // //   );

// // //   const x = useTransform(
// // //     scrollYProgress,
// // //     [0, 1],
// // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // //   );

// // //   const opacity = useTransform(
// // //     scrollYProgress,
// // //     [0.1, 0.2, 0.8, 0.9],
// // //     [0, 1, 1, 0]
// // //   );

// // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.98, 1]);

// // //   const display = useTransform(scrollYProgress, (v) =>
// // //     v < 0.1 || v > 0.9 ? "none" : "flex"
// // //   );

// // //   return (
// // //     <section
// // //       ref={sectionRef}
// // //       className="relative hidden md:block h-[160vh] bg-[#0B0B0F]"
// // //     >
// // //       <motion.div
// // //         style={{ opacity, scale, display }}
// // //         className="fixed inset-0 z-30 flex items-center pointer-events-none"
// // //       >
// // //         <div className="mx-auto w-full max-w-6xl px-16">

// // //           {/* HEADER */}
// // //           <div className="mb-14 pointer-events-auto">
// // //             <h2 className="text-5xl font-extrabold text-white tracking-tight">
// // //               What Legal Experts Say
// // //             </h2>
// // //             <p className="mt-4 text-lg text-neutral-400 max-w-xl">
// // //               Feedback from professionals using Jurident every day.
// // //             </p>
// // //           </div>

// // //           {/* SLIDER */}
// // //           <div className="relative overflow-hidden pointer-events-auto">
// // //             <motion.div className="flex" style={{ x }}>
// // //               {testimonials.map((t, i) => (
// // //                 <div key={i} className="min-w-full px-6">
// // //                   <div
// // //                     className="
// // //                       relative
// // //                       rounded-[28px]
// // //                       bg-gradient-to-br from-[#141421] via-[#10101A] to-[#0C0C14]
// // //                       border border-white/10
// // //                       p-12
// // //                       shadow-[0_30px_120px_rgba(0,0,0,0.65)]
// // //                       backdrop-blur-xl
// // //                     "
// // //                   >
// // //                     {/* GLOW */}
// // //                     <div className="absolute inset-0 rounded-[28px] bg-gradient-to-r from-indigo-500/10 via-purple-500/10 to-cyan-500/10 blur-2xl" />

// // //                     {/* QUOTE MARK */}
// // //                     <div className="relative text-indigo-400 text-6xl font-serif leading-none mb-6">
// // //                       “
// // //                     </div>

// // //                     {/* TEXT */}
// // //                     <p className="relative text-[20px] leading-[1.75] text-neutral-200 max-w-4xl">
// // //                       {t.text}
// // //                     </p>

// // //                     {/* DIVIDER */}
// // //                     <div className="my-10 h-px w-full bg-gradient-to-r from-transparent via-white/20 to-transparent" />

// // //                     {/* AUTHOR */}
// // //                     <div className="relative flex items-center gap-4">
// // //                       <div className="h-12 w-12 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white shadow-lg">
// // //                         <User size={18} />
// // //                       </div>
// // //                       <div>
// // //                         <p className="font-semibold text-white">
// // //                           {t.name}
// // //                         </p>
// // //                         <p className="text-sm text-neutral-400">
// // //                           {t.role}
// // //                         </p>
// // //                       </div>
// // //                     </div>

// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </motion.div>
// // //           </div>

// // //         </div>
// // //       </motion.div>
// // //     </section>
// // //   );
// // // }





// // // import { motion, useScroll, useTransform } from "framer-motion";
// // // import { useRef, useEffect, useState } from "react";
// // // import { User } from "lucide-react";

// // // const testimonials = [
// // //   { text: "" },
// // //   {
// // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // //     name: "Ayush Mangal Gupta",
// // //     role: "Lawyer / High Court",
// // //   },
// // //   {
// // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // //     name: "Vasu Sangal",
// // //     role: "Lawyer / District Court",
// // //   },
// // //   {
// // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // //     name: "Ajay Kumar",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   {
// // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // //     name: "Krishnam Soni",
// // //     role: "Lawyer / High Court",
// // //   },
// // //   {
// // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // //     name: "Indresh Goswami",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   {
// // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // //     name: "Nitin Shrivastava",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   { role: "" },
// // // ];

// // // export default function Testimonials() {
// // //   const sectionRef = useRef(null);
// // //   const [mounted, setMounted] = useState(false);

// // //   useEffect(() => setMounted(true), []);

// // //   const { scrollYProgress } = useScroll(
// // //     mounted ? { target: sectionRef, offset: ["start start", "end end"] } : {}
// // //   );

// // //   const x = useTransform(
// // //     scrollYProgress,
// // //     [0, 1],
// // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // //   );

// // //   const opacity = useTransform(
// // //     scrollYProgress,
// // //     [0.1, 0.2, 0.8, 0.9],
// // //     [0, 1, 1, 0]
// // //   );

// // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.98, 1]);

// // //   const display = useTransform(scrollYProgress, (v) =>
// // //     v < 0.1 || v > 0.9 ? "none" : "flex"
// // //   );

// // //   return (
// // //     <section
// // //       ref={sectionRef}
// // //       className="relative hidden md:block h-[160vh] bg-[#0B0B0F]"
// // //     >
// // //       <motion.div
// // //         style={{ opacity, scale, display }}
// // //         className="fixed inset-0 z-30 flex items-center pointer-events-none"
// // //       >
// // //         <div className="mx-auto w-full max-w-6xl px-16">

// // //           {/* HEADER */}
// // //           <div className="mb-14 pointer-events-auto">
// // //             <h2 className="text-5xl font-extrabold text-white tracking-tight">
// // //               What Legal Experts Say
// // //             </h2>
// // //             <p className="mt-4 text-lg text-neutral-400 max-w-xl">
// // //               Feedback from professionals using Jurident every day.
// // //             </p>
// // //           </div>

// // //           {/* SLIDER */}
// // //           <div className="relative overflow-hidden pointer-events-auto">
// // //             <motion.div className="flex" style={{ x }}>
// // //               {testimonials.map((t, i) => (
// // //                 <div key={i} className="min-w-full px-6">
// // //                   <div
// // //                     className="
// // //                       relative
// // //                       rounded-[28px]
// // //                       bg-gradient-to-br from-[#141421] via-[#10101A] to-[#0C0C14]
// // //                       border border-white/10
// // //                       p-12
// // //                       shadow-[0_30px_120px_rgba(0,0,0,0.65)]
// // //                       backdrop-blur-xl
// // //                     "
// // //                   >
// // //                     {/* GLOW */}
// // //                     <div className="absolute inset-0 rounded-[28px] bg-gradient-to-r from-indigo-500/10 via-purple-500/10 to-cyan-500/10 blur-2xl" />

// // //                     {/* QUOTE MARK */}
// // //                     <div className="relative text-indigo-400 text-6xl font-serif leading-none mb-6">
// // //                       “
// // //                     </div>

// // //                     {/* TEXT */}
// // //                     <p className="relative text-[20px] leading-[1.75] text-neutral-200 max-w-4xl">
// // //                       {t.text}
// // //                     </p>

// // //                     {/* DIVIDER */}
// // //                     <div className="my-10 h-px w-full bg-gradient-to-r from-transparent via-white/20 to-transparent" />

// // //                     {/* AUTHOR */}
// // //                     <div className="relative flex items-center gap-4">
// // //                       <div className="h-12 w-12 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white shadow-lg">
// // //                         <User size={18} />
// // //                       </div>
// // //                       <div>
// // //                         <p className="font-semibold text-white">
// // //                           {t.name}
// // //                         </p>
// // //                         <p className="text-sm text-neutral-400">
// // //                           {t.role}
// // //                         </p>
// // //                       </div>
// // //                     </div>

// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </motion.div>
// // //           </div>

// // //         </div>
// // //       </motion.div>
// // //     </section>
// // //   );
// // // }









// // // import { motion, useScroll, useTransform } from "framer-motion";
// // // import { useRef, useEffect, useState } from "react";
// // // import { User } from "lucide-react";

// // // const testimonials = [
// // //   { text: "" },
// // //   {
// // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // //     name: "Ayush Mangal Gupta",
// // //     role: "Lawyer / High Court",
// // //   },
// // //   {
// // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // //     name: "Vasu Sangal",
// // //     role: "Lawyer / District Court",
// // //   },
// // //   {
// // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // //     name: "Ajay Kumar",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   {
// // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // //     name: "Krishnam Soni",
// // //     role: "Lawyer / High Court",
// // //   },
// // //   {
// // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // //     name: "Indresh Goswami",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   {
// // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // //     name: "Nitin Shrivastava",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   { role: "" },
// // // ];

// // // export default function Testimonials() {
// // //   const sectionRef = useRef(null);
// // //   const [mounted, setMounted] = useState(false);

// // //   useEffect(() => setMounted(true), []);

// // //   const { scrollYProgress } = useScroll(
// // //     mounted ? { target: sectionRef, offset: ["start start", "end end"] } : {}
// // //   );

// // //   /* 🐢 SLOWER SCROLL (spread progress) */
// // //   const x = useTransform(
// // //     scrollYProgress,
// // //     [0, 1],
// // //     ["0%", `-${(testimonials.length - 1) * 80}%`]
// // //   );

// // //   const opacity = useTransform(
// // //     scrollYProgress,
// // //     [0.08, 0.18, 0.82, 0.92],
// // //     [0, 1, 1, 0]
// // //   );

// // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.97, 1]);

// // //   const display = useTransform(scrollYProgress, (v) =>
// // //     v < 0.08 || v > 0.92 ? "none" : "flex"
// // //   );

// // //   return (
// // //     <section
// // //       ref={sectionRef}
// // //       className="relative hidden md:block h-[160vh] bg-[#F6F7FB]"
// // //     >
// // //       <motion.div
// // //         style={{ opacity, scale, display }}
// // //         className="fixed inset-0 z-30 flex items-center pointer-events-none"
// // //       >
// // //         <div className="mx-auto w-full max-w-6xl px-16">

// // //           {/* HEADER */}
// // //           <div className="mb-14 pointer-events-auto">
// // //             <h2 className="text-5xl font-extrabold tracking-tight text-[#0F172A]">
// // //               What Legal Experts Say
// // //             </h2>
// // //             <p className="mt-4 text-lg text-slate-600 max-w-xl">
// // //               Feedback from professionals using Jurident every day.
// // //             </p>
// // //           </div>

// // //           {/* SLIDER */}
// // //           <div className="relative overflow-hidden pointer-events-auto">
// // //             <motion.div className="flex" style={{ x }}>
// // //               {testimonials.map((t, i) => (
// // //                 <div key={i} className="min-w-full px-6">
// // //                   <div
// // //                     className="
// // //                       relative
// // //                       rounded-[26px]
// // //                       bg-white/70
// // //                       backdrop-blur-xl
// // //                       border border-slate-200
// // //                       p-12
// // //                       shadow-[0_30px_80px_rgba(15,23,42,0.12)]
// // //                     "
// // //                   >
// // //                     {/* SOFT ACCENT */}
// // //                     <div className="absolute inset-0 rounded-[26px] bg-gradient-to-br from-indigo-200/30 via-purple-200/20 to-cyan-200/20 pointer-events-none" />

// // //                     {/* QUOTE */}
// // //                     <div className="relative text-indigo-500 text-6xl font-serif leading-none mb-6">
// // //                       “
// // //                     </div>

// // //                     {/* TEXT */}
// // //                     <p className="relative text-[20px] leading-[1.75] text-slate-800 max-w-4xl">
// // //                       {t.text}
// // //                     </p>

// // //                     {/* DIVIDER */}
// // //                     <div className="my-10 h-px w-full bg-gradient-to-r from-transparent via-slate-300 to-transparent" />

// // //                     {/* AUTHOR */}
// // //                     <div className="relative flex items-center gap-4">
// // //                       <div className="h-12 w-12 rounded-full bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center text-white shadow-md">
// // //                         <User size={18} />
// // //                       </div>
// // //                       <div>
// // //                         <p className="font-semibold text-slate-900">
// // //                           {t.name}
// // //                         </p>
// // //                         <p className="text-sm text-slate-600">
// // //                           {t.role}
// // //                         </p>
// // //                       </div>
// // //                     </div>

// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </motion.div>
// // //           </div>

// // //         </div>
// // //       </motion.div>
// // //     </section>
// // //   );
// // // }













// // // import { motion, useScroll, useTransform } from "framer-motion";
// // // import { useRef, useEffect, useState } from "react";
// // // import { User } from "lucide-react";

// // // const testimonials = [
// // //   { text: "" },
// // //   {
// // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // //     name: "Ayush Mangal Gupta",
// // //     role: "Lawyer / High Court",
// // //   },
// // //   {
// // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // //     name: "Vasu Sangal",
// // //     role: "Lawyer / District Court",
// // //   },
// // //   {
// // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // //     name: "Ajay Kumar",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   {
// // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // //     name: "Krishnam Soni",
// // //     role: "Lawyer / High Court",
// // //   },
// // //   {
// // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // //     name: "Indresh Goswami",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   {
// // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // //     name: "Nitin Shrivastava",
// // //     role: "Lawyer / Supreme Court",
// // //   },
// // //   { role: "" },
// // // ];

// // // export default function Testimonials() {
// // //   const sectionRef = useRef(null);
// // //   const [mounted, setMounted] = useState(false);

// // //   useEffect(() => setMounted(true), []);

// // //   const { scrollYProgress } = useScroll(
// // //     mounted ? { target: sectionRef, offset: ["start start", "end end"] } : {}
// // //   );

// // //   const x = useTransform(
// // //     scrollYProgress,
// // //     [0, 1],
// // //     ["0%", `-${(testimonials.length - 1) * 80}%`]
// // //   );

// // //   const opacity = useTransform(
// // //     scrollYProgress,
// // //     [0.08, 0.18, 0.82, 0.92],
// // //     [0, 1, 1, 0]
// // //   );

// // //   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.97, 1]);

// // //   const display = useTransform(scrollYProgress, (v) =>
// // //     v < 0.08 || v > 0.92 ? "none" : "flex"
// // //   );

// // //   return (
// // //     <section
// // //       ref={sectionRef}
// // //       className="relative hidden md:block h-[160vh] bg-[#EEF1F6]"
// // //     >
// // //       <motion.div
// // //         style={{ opacity, scale, display }}
// // //         className="fixed inset-0 z-30 flex items-center pointer-events-none"
// // //       >
// // //         <div className="mx-auto w-full max-w-6xl px-16">

// // //           {/* HEADER */}
// // //           <div className="mb-14 pointer-events-auto">
// // //             <h2 className="text-5xl font-extrabold tracking-tight text-[#0B1220]">
// // //               What Legal Experts Say
// // //             </h2>
// // //             <p className="mt-4 text-lg text-slate-700 max-w-xl">
// // //               Feedback from professionals using Jurident every day.
// // //             </p>
// // //           </div>

// // //           {/* SLIDER */}
// // //           <div className="relative overflow-hidden pointer-events-auto">
// // //             <motion.div className="flex" style={{ x }}>
// // //               {testimonials.map((t, i) => (
// // //                 <div key={i} className="min-w-full px-6">
// // //                   <div
// // //                     className="
// // //                       relative
// // //                       rounded-[26px]
// // //                       bg-white
// // //                       border border-slate-300
// // //                       p-12
// // //                       shadow-[0_35px_90px_rgba(15,23,42,0.18)]
// // //                     "
// // //                   >
// // //                     {/* CONTRAST ACCENT */}
// // //                     <div className="absolute inset-0 rounded-[26px] bg-gradient-to-br from-indigo-300/25 via-purple-300/15 to-cyan-300/15 pointer-events-none" />

// // //                     {/* QUOTE */}
// // //                     <div className="relative text-indigo-600 text-6xl font-serif leading-none mb-6">
// // //                       “
// // //                     </div>

// // //                     {/* TEXT */}
// // //                     <p className="relative text-[20px] leading-[1.75] text-slate-900 max-w-4xl">
// // //                       {t.text}
// // //                     </p>

// // //                     {/* DIVIDER */}
// // //                     <div className="my-10 h-px w-full bg-gradient-to-r from-transparent via-slate-400 to-transparent" />

// // //                     {/* AUTHOR */}
// // //                     <div className="relative flex items-center gap-4">
// // //                       <div className="h-12 w-12 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-lg">
// // //                         <User size={18} />
// // //                       </div>
// // //                       <div>
// // //                         <p className="font-semibold text-slate-900">
// // //                           {t.name}
// // //                         </p>
// // //                         <p className="text-sm text-slate-700">
// // //                           {t.role}
// // //                         </p>
// // //                       </div>
// // //                     </div>

// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </motion.div>
// // //           </div>

// // //         </div>
// // //       </motion.div>
// // //     </section>
// // //   );
// // // }





























// // import { motion, useScroll, useTransform } from "framer-motion";
// // import { useRef, useEffect, useState } from "react";
// // import { User } from "lucide-react";

// // const testimonials = [
// //   {
// //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// //     name: "Ayush Mangal Gupta",
// //     role: "Lawyer · High Court",
// //   },
// //   {
// //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. Intelligent case scheduling ensures nothing falls through the cracks.",
// //     name: "Vasu Sangal",
// //     role: "Lawyer · District Court",
// //   },
// //   {
// //     text: "The team assistance feature greatly enhances collaboration. Sharing case details, tasks, and updates is effortless, keeping everyone aligned throughout the legal process.",
// //     name: "Ajay Kumar",
// //     role: "Lawyer · Supreme Court",
// //   },
// //   {
// //     text: "Efficient case file management has never been easier. The organized and intuitive system saves me hours every week.",
// //     name: "Krishnam Soni",
// //     role: "Lawyer · High Court",
// //   },
// //   {
// //     text: "Cause list generation and event management are extremely well executed. Every hearing and deadline stays crystal clear.",
// //     name: "Indresh Goswami",
// //     role: "Lawyer · Supreme Court",
// //   },
// //   {
// //     text: "Seamless case data export from High Court and District Court portals eliminates manual work and keeps records accurate.",
// //     name: "Nitin Shrivastava",
// //     role: "Lawyer · Supreme Court",
// //   },
// // ];

// // export default function Testimonials() {
// //   const sectionRef = useRef(null);
// //   const [mounted, setMounted] = useState(false);

// //   useEffect(() => setMounted(true), []);

// //   const { scrollYProgress } = useScroll(
// //     mounted
// //       ? { target: sectionRef, offset: ["start start", "end end"] }
// //       : {}
// //   );

// //   const x = useTransform(
// //     scrollYProgress,
// //     [0, 1],
// //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// //   );

// //   const opacity = useTransform(
// //     scrollYProgress,
// //     [0.05, 0.15, 0.85, 0.95],
// //     [0, 1, 1, 0]
// //   );

// //   const scale = useTransform(scrollYProgress, [0.08, 0.2], [0.96, 1]);

// //   return (
// //     <section
// //       ref={sectionRef}
// //       className="relative hidden md:block h-[180vh] bg-gradient-to-b from-[#EEF1F6] via-[#F7F8FC] to-white"
// //     >
// //       {/* Ambient background glow */}
// //       <div className="absolute -top-40 -left-40 w-[520px] h-[520px] bg-indigo-300/20 rounded-full blur-[160px]" />
// //       <div className="absolute top-1/3 -right-40 w-[520px] h-[520px] bg-amber-300/20 rounded-full blur-[160px]" />

// //       <motion.div
// //         style={{ opacity, scale }}
// //         className="fixed inset-0 z-30 flex items-center"
// //       >
// //         <div className="mx-auto w-full max-w-6xl px-16">

// //           {/* HEADER */}
// //           <div className="mb-16">
// //             <motion.h2
// //               initial={{ y: 20, opacity: 0 }}
// //               whileInView={{ y: 0, opacity: 1 }}
// //               transition={{ duration: 0.8 }}
// //               className="text-5xl font-extrabold tracking-tight text-[#0B1220]"
// //             >
// //               Trusted by Legal Professionals
// //             </motion.h2>
// //             <p className="mt-4 text-lg text-slate-600 max-w-xl">
// //               Real experiences from lawyers using Jurident every day.
// //             </p>
// //           </div>

// //           {/* SLIDER */}
// //           <div className="relative overflow-hidden">
// //             <motion.div className="flex" style={{ x }}>
// //               {testimonials.map((t, i) => (
// //                 <div key={i} className="min-w-full px-8">
// //                   <motion.div
// //                     whileHover={{ y: -6 }}
// //                     transition={{ duration: 0.4 }}
// //                     className="
// //                       relative rounded-[30px]
// //                       bg-white/80 backdrop-blur-xl
// //                       border border-slate-200
// //                       p-14
// //                       shadow-[0_40px_100px_rgba(15,23,42,0.18)]
// //                     "
// //                   >
// //                     {/* Gradient overlay */}
// //                     <div className="absolute inset-0 rounded-[30px] bg-gradient-to-br from-indigo-400/15 via-purple-300/10 to-amber-300/10 pointer-events-none" />

// //                     {/* Quote */}
// //                     <motion.div
// //                       initial={{ scale: 0.8, opacity: 0 }}
// //                       animate={{ scale: 1, opacity: 1 }}
// //                       transition={{ delay: 0.2 }}
// //                       className="relative text-indigo-500 text-6xl font-serif leading-none mb-8"
// //                     >
// //                       “
// //                     </motion.div>

// //                     {/* Text */}
// //                     <p className="relative text-[22px] leading-[1.75] text-slate-900 max-w-4xl">
// //                       {t.text}
// //                     </p>

// //                     {/* Divider */}
// //                     <div className="my-12 h-px w-full bg-gradient-to-r from-transparent via-slate-300 to-transparent" />

// //                     {/* Author */}
// //                     <motion.div
// //                       initial={{ opacity: 0, y: 10 }}
// //                       whileInView={{ opacity: 1, y: 0 }}
// //                       transition={{ duration: 0.6 }}
// //                       className="relative flex items-center gap-4"
// //                     >
// //                       <div className="h-12 w-12 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-lg">
// //                         <User size={18} />
// //                       </div>
// //                       <div>
// //                         <p className="font-semibold text-slate-900">
// //                           {t.name}
// //                         </p>
// //                         <p className="text-sm text-slate-600">
// //                           {t.role}
// //                         </p>
// //                       </div>
// //                     </motion.div>
// //                   </motion.div>
// //                 </div>
// //               ))}
// //             </motion.div>
// //           </div>

// //           {/* Progress Indicator */}
// //           <div className="mt-10 h-[3px] w-full bg-slate-200 rounded-full overflow-hidden">
// //             <motion.div
// //               style={{ scaleX: scrollYProgress }}
// //               className="h-full bg-gradient-to-r from-indigo-600 to-amber-500 origin-left"
// //             />
// //           </div>

// //         </div>
// //       </motion.div>
// //     </section>
// //   );
// // }




















// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef, useEffect, useState } from "react";
// import { User } from "lucide-react";

// const testimonials = [
//   {
//     text:""
//   },
//   {
//     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
//     name: "Ayush Mangal Gupta",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. Intelligent case scheduling ensures nothing falls through the cracks.",
//     name: "Vasu Sangal",
//     role: "Lawyer · District Court",
//   },
//   {
//     text: "The team assistance feature greatly enhances collaboration. Sharing case details, tasks, and updates is effortless, keeping everyone aligned throughout the legal process.",
//     name: "Ajay Kumar",
//     role: "Lawyer · Supreme Court",
//   },
//   {
//     text: "Efficient case file management has never been easier. The organized and intuitive system saves me hours every week.",
//     name: "Krishnam Soni",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Cause list generation and event management are extremely well executed. Every hearing and deadline stays crystal clear.",
//     name: "Indresh Goswami",
//     role: "Lawyer · Supreme Court",
//   },
//   {
//     text: "Seamless case data export from High Court and District Court portals eliminates manual work and keeps records accurate.",
//     name: "Nitin Shrivastava",
//     role: "Lawyer · Supreme Court",
//   },
//   {
//     text:""
//   },
// ];

// export default function Testimonials() {
//   const sectionRef = useRef(null);
//   const [mounted, setMounted] = useState(false);

//   useEffect(() => setMounted(true), []);

//   const { scrollYProgress } = useScroll(
//     mounted
//       ? { target: sectionRef, offset: ["start start", "end end"] }
//       : {}
//   );

//   /* Horizontal movement */
//   const x = useTransform(
//     scrollYProgress,
//     [0, 1],
//     ["0%", `-${(testimonials.length - 1) * 100}%`]
//   );

//   /* Fade in / out */
//   const opacity = useTransform(
//     scrollYProgress,
//     [0.06, 0.15, 0.85, 0.94],
//     [0, 1, 1, 0]
//   );

//   /* Scale */
//   const scale = useTransform(scrollYProgress, [0.08, 0.2], [0.96, 1]);

//   /* 🔒 HARD VISIBILITY GATE (FIXES BLEED ISSUE) */
//   const display = useTransform(scrollYProgress, (v) =>
//     v >= 0.06 && v <= 0.94 ? "flex" : "none"
//   );

//   const pointerEvents = useTransform(scrollYProgress, (v) =>
//     v >= 0.06 && v <= 0.94 ? "auto" : "none"
//   );

//   return (
//     <section
//       ref={sectionRef}
//       className="
//         relative hidden md:block h-[180vh] overflow-hidden
//         bg-gradient-to-b from-[#EEF1F6] via-[#F7F8FC] to-white
//       "
//     >
//       {/* Ambient background glow */}
//       <div className="absolute -top-40 -left-40 w-[520px] h-[520px] bg-indigo-300/20 rounded-full blur-[160px]" />
//       <div className="absolute top-1/3 -right-40 w-[520px] h-[520px] bg-amber-300/20 rounded-full blur-[160px]" />

//       {/* FIXED CONTENT — STRICTLY CONTROLLED */}
//       <motion.div
//         style={{ opacity, scale, display, pointerEvents }}
//         className="fixed inset-0 z-30 flex items-center"
//       >
//         <div className="mx-auto w-full max-w-6xl px-16">

//           {/* HEADER */}
//           <div className="mb-16">
//             <h2 className="text-5xl font-extrabold tracking-tight text-[#0B1220]">
//               Trusted by Legal Professionals
//             </h2>
//             <p className="mt-4 text-lg text-slate-600 max-w-xl">
//               Real experiences from lawyers using Jurident every day.
//             </p>
//           </div>

//           {/* SLIDER */}
//           <div className="relative overflow-hidden">
//             <motion.div className="flex" style={{ x }}>
//               {testimonials.map((t, i) => (
//                 <div key={i} className="min-w-full px-8">
//                   <motion.div
//                     whileHover={{ y: -6 }}
//                     transition={{ duration: 0.4 }}
//                     className="
//                       relative rounded-[30px]
//                       bg-white/80 backdrop-blur-xl
//                       border border-slate-200
//                       p-14
//                       shadow-[0_40px_100px_rgba(15,23,42,0.18)]
//                     "
//                   >
//                     {/* Gradient overlay */}
//                     <div className="absolute inset-0 rounded-[30px] bg-gradient-to-br from-indigo-400/15 via-purple-300/10 to-amber-300/10 pointer-events-none" />

//                     {/* Quote */}
//                     <div className="relative text-indigo-500 text-6xl font-serif leading-none mb-8">
//                       “
//                     </div>

//                     {/* Text */}
//                     <p className="relative text-[22px] leading-[1.75] text-slate-900 max-w-4xl">
//                       {t.text}
//                     </p>

//                     {/* Divider */}
//                     <div className="my-12 h-px w-full bg-gradient-to-r from-transparent via-slate-300 to-transparent" />

//                     {/* Author */}
//                     <div className="relative flex items-center gap-4">
//                       <div className="h-12 w-12 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-lg">
//                         <User size={18} />
//                       </div>
//                       <div>
//                         <p className="font-semibold text-slate-900">
//                           {t.name}
//                         </p>
//                         <p className="text-sm text-slate-600">
//                           {t.role}
//                         </p>
//                       </div>
//                     </div>

//                   </motion.div>
//                 </div>
//               ))}
//             </motion.div>
//           </div>

//           {/* PROGRESS BAR */}
//           <div className="mt-10 h-[3px] w-full bg-slate-200 rounded-full overflow-hidden">
//             <motion.div
//               style={{ scaleX: scrollYProgress }}
//               className="h-full bg-gradient-to-r from-indigo-600 to-amber-500 origin-left"
//             />
//           </div>

//         </div>
//       </motion.div>
//     </section>
//   );
// }















// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef, useEffect, useState } from "react";
// import { User } from "lucide-react";

// const testimonials = [
//   {
//     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
//     name: "Ayush Mangal Gupta",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. Intelligent case scheduling ensures nothing falls through the cracks.",
//     name: "Vasu Sangal",
//     role: "Lawyer · District Court",
//   },
//   {
//     text: "The team assistance feature greatly enhances collaboration. Sharing case details, tasks, and updates is effortless, keeping everyone aligned throughout the legal process.",
//     name: "Ajay Kumar",
//     role: "Lawyer · Supreme Court",
//   },
//   {
//     text: "Efficient case file management has never been easier. The organized and intuitive system saves me hours every week.",
//     name: "Krishnam Soni",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Cause list generation and event management are extremely well executed. Every hearing and deadline stays crystal clear.",
//     name: "Indresh Goswami",
//     role: "Lawyer · Supreme Court",
//   },
//   {
//     text: "Seamless case data export from High Court and District Court portals eliminates manual work and keeps records accurate.",
//     name: "Nitin Shrivastava",
//     role: "Lawyer · Supreme Court",
//   },
// ];

// export default function Testimonials() {
//   const sectionRef = useRef(null);
//   const [mounted, setMounted] = useState(false);

//   useEffect(() => setMounted(true), []);

//   const { scrollYProgress } = useScroll(
//     mounted
//       ? { target: sectionRef, offset: ["start start", "end end"] }
//       : {}
//   );

//   const x = useTransform(
//     scrollYProgress,
//     [0, 1],
//     ["0%", `-${(testimonials.length - 1) * 100}%`]
//   );

//   const opacity = useTransform(
//     scrollYProgress,
//     [0.08, 0.18, 0.82, 0.92],
//     [0, 1, 1, 0]
//   );

//   const scale = useTransform(scrollYProgress, [0.1, 0.2], [0.97, 1]);

//   const display = useTransform(scrollYProgress, (v) =>
//     v >= 0.08 && v <= 0.92 ? "flex" : "none"
//   );

//   const pointerEvents = useTransform(scrollYProgress, (v) =>
//     v >= 0.08 && v <= 0.92 ? "auto" : "none"
//   );

//   return (
//     <section
//       ref={sectionRef}
//       className="
//         relative hidden md:block h-[140vh] overflow-hidden
//         bg-gradient-to-b from-[#EEF1F6] via-[#F7F8FC] to-white
//       "
//     >
//       {/* Ambient glow */}
//       <div className="absolute -top-32 -left-32 w-[420px] h-[420px] bg-indigo-300/20 rounded-full blur-[140px]" />
//       <div className="absolute top-1/3 -right-32 w-[420px] h-[420px] bg-amber-300/20 rounded-full blur-[140px]" />

//       <motion.div
//         style={{ opacity, scale, display, pointerEvents }}
//         className="fixed inset-0 z-30 flex items-center"
//       >
//         <div className="mx-auto w-full max-w-6xl px-12">

//           {/* Header */}
//           <div className="mb-10">
//             <h2 className="text-4xl font-extrabold tracking-tight text-[#0B1220]">
//               Trusted by Legal Professionals
//             </h2>
//             <p className="mt-3 text-base text-slate-600 max-w-xl">
//               Real experiences from lawyers using Jurident every day.
//             </p>
//           </div>

//           {/* Slider */}
//           <div className="relative overflow-hidden">
//             <motion.div className="flex" style={{ x }}>
//               {testimonials.map((t, i) => (
//                 <div key={i} className="min-w-full px-4">
//                   <motion.div
//                     whileHover={{ y: -4 }}
//                     transition={{ duration: 0.35 }}
//                     className="
//                       relative rounded-[26px]
//                       bg-white/80 backdrop-blur-xl
//                       border border-slate-200
//                       p-10
//                       shadow-[0_30px_80px_rgba(15,23,42,0.18)]
//                     "
//                   >
//                     <div className="absolute inset-0 rounded-[26px] bg-gradient-to-br from-indigo-400/15 via-purple-300/10 to-amber-300/10 pointer-events-none" />

//                     <div className="relative text-indigo-500 text-5xl font-serif mb-6">
//                       “
//                     </div>

//                     <p className="relative text-[20px] leading-[1.65] text-slate-900">
//                       {t.text}
//                     </p>

//                     <div className="my-8 h-px w-full bg-gradient-to-r from-transparent via-slate-300 to-transparent" />

//                     <div className="relative flex items-center gap-4">
//                       <div className="h-11 w-11 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-lg">
//                         <User size={16} />
//                       </div>
//                       <div>
//                         <p className="font-semibold text-slate-900">
//                           {t.name}
//                         </p>
//                         <p className="text-sm text-slate-600">
//                           {t.role}
//                         </p>
//                       </div>
//                     </div>

//                   </motion.div>
//                 </div>
//               ))}
//             </motion.div>
//           </div>

//           {/* Progress */}
//           <div className="mt-8 h-[3px] w-full bg-slate-200 rounded-full overflow-hidden">
//             <motion.div
//               style={{ scaleX: scrollYProgress }}
//               className="h-full bg-gradient-to-r from-indigo-600 to-amber-500 origin-left"
//             />
//           </div>

//         </div>
//       </motion.div>
//     </section>
//   );
// }















// import { motion, AnimatePresence } from "framer-motion";
// import { useState, useEffect } from "react";
// import { User } from "lucide-react";

// const testimonials = [
//   {
//     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth.",
//     name: "Ayush Mangal Gupta",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Highly efficient and remarkably intuitive. The intelligent scheduling ensures nothing ever falls through the cracks.",
//     name: "Vasu Sangal",
//     role: "Lawyer · District Court",
//   },
//   {
//     text: "The team collaboration features are outstanding. Case sharing and task updates feel effortless and precise.",
//     name: "Ajay Kumar",
//     role: "Lawyer · Supreme Court",
//   },
//   {
//     text: "The organized file management saves me hours every week. It lets me focus entirely on my clients.",
//     name: "Krishnam Soni",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Cause list and event tracking are extremely reliable. Every hearing and deadline stays clear.",
//     name: "Indresh Goswami",
//     role: "Lawyer · Supreme Court",
//   },
// ];

// export default function Testimonials() {
//   const [index, setIndex] = useState(0);

//   // Auto rotate
//   useEffect(() => {
//     const timer = setInterval(() => {
//       setIndex((prev) => (prev + 1) % testimonials.length);
//     }, 5000);
//     return () => clearInterval(timer);
//   }, []);

//   return (
//     <section className="relative py-32 bg-gradient-to-b from-[#F6F8FC] via-white to-[#F9FAFF] overflow-hidden">

//       {/* Ambient luxury glow */}
//       <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-indigo-300/20 rounded-full blur-[160px]" />
//       <div className="absolute bottom-0 -right-40 w-[500px] h-[500px] bg-amber-300/20 rounded-full blur-[160px]" />

//       <div className="relative z-10 max-w-6xl mx-auto px-6">

//         {/* Header */}
//         <div className="text-center mb-20">
//           <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#0B1220]">
//             Trusted by Legal Professionals
//           </h2>
//           <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">
//             Real feedback from lawyers using Jurident in their daily practice.
//           </p>
//         </div>

//         {/* Cards */}
//         <div className="relative flex justify-center items-center min-h-[360px]">

//           {/* Background cards */}
//           {testimonials.map((t, i) => {
//             const offset = i - index;
//             if (Math.abs(offset) > 2) return null;

//             return (
//               <motion.div
//                 key={i}
//                 animate={{
//                   scale: offset === 0 ? 1 : 0.92,
//                   opacity: offset === 0 ? 1 : 0.25,
//                   x: offset * 260,
//                 }}
//                 transition={{ duration: 0.6, ease: "easeOut" }}
//                 className="
//                   absolute w-full max-w-xl
//                   rounded-[28px]
//                   bg-white/80 backdrop-blur-xl
//                   border border-slate-200
//                   shadow-[0_30px_80px_rgba(15,23,42,0.18)]
//                   p-10
//                 "
//                 style={{ zIndex: 10 - Math.abs(offset) }}
//               >
//                 <div className="text-indigo-500 text-5xl font-serif mb-6">“</div>

//                 <p className="text-[20px] leading-relaxed text-slate-900">
//                   {t.text}
//                 </p>

//                 <div className="mt-8 pt-6 border-t border-slate-200 flex items-center gap-4">
//                   <div className="h-11 w-11 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-lg">
//                     <User size={16} />
//                   </div>
//                   <div>
//                     <p className="font-semibold text-slate-900">{t.name}</p>
//                     <p className="text-sm text-slate-600">{t.role}</p>
//                   </div>
//                 </div>
//               </motion.div>
//             );
//           })}
//         </div>

//         {/* Dots */}
//         <div className="flex justify-center gap-3 mt-14">
//           {testimonials.map((_, i) => (
//             <button
//               key={i}
//               onClick={() => setIndex(i)}
//               className={`h-2.5 w-2.5 rounded-full transition-all ${
//                 i === index
//                   ? "bg-indigo-600 w-6"
//                   : "bg-slate-300 hover:bg-slate-400"
//               }`}
//             />
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// }
















// import { motion } from "framer-motion";
// import { useState } from "react";
// import { User } from "lucide-react";
// import { ChevronLeft, ChevronRight } from "lucide-react";

// const testimonials = [
//   {
//     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth.",
//     name: "Ayush Mangal Gupta",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Highly efficient and remarkably intuitive. The intelligent scheduling ensures nothing ever falls through the cracks.",
//     name: "Vasu Sangal",
//     role: "Lawyer · District Court",
//   },
//   {
//     text: "The team collaboration features are outstanding. Case sharing and task updates feel effortless and precise.",
//     name: "Ajay Kumar",
//     role: "Lawyer · Supreme Court",
//   },
//   {
//     text: "The organized file management saves me hours every week. It lets me focus entirely on my clients.",
//     name: "Krishnam Soni",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Cause list and event tracking are extremely reliable. Every hearing and deadline stays clear.",
//     name: "Indresh Goswami",
//     role: "Lawyer · Supreme Court",
//   },
// ];

// export default function Testimonials() {
//   const [index, setIndex] = useState(0);

//   const next = () => {
//     setIndex((prev) =>
//       prev === testimonials.length - 1 ? 0 : prev + 1
//     );
//   };

//   const prev = () => {
//     setIndex((prev) =>
//       prev === 0 ? testimonials.length - 1 : prev - 1
//     );
//   };

//   return (
//     <section className="relative py-32 bg-gradient-to-b from-[#F6F8FC] via-white to-[#F9FAFF] overflow-hidden">

//       {/* Ambient glow */}
//       <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-indigo-300/20 rounded-full blur-[160px]" />
//       <div className="absolute bottom-0 -right-40 w-[500px] h-[500px] bg-amber-300/20 rounded-full blur-[160px]" />

//       <div className="relative z-10 max-w-6xl mx-auto px-6">

//         {/* Header */}
//         <div className="text-center mb-20">
//           <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#0B1220]">
//             Trusted by Legal Professionals
//           </h2>
//           <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">
//             Real feedback from lawyers using Jurident in their daily practice.
//           </p>
//         </div>

//         {/* Cards */}
//         <div className="relative flex justify-center items-center min-h-[360px]">

//           {testimonials.map((t, i) => {
//             const offset = i - index;
//             if (Math.abs(offset) > 2) return null;

//             return (
//               <motion.div
//                 key={i}
//                 animate={{
//                   scale: offset === 0 ? 1 : 0.92,
//                   opacity: offset === 0 ? 1 : 0.25,
//                   x: offset * 260,
//                 }}
//                 transition={{ duration: 0.6, ease: "easeOut" }}
//                 className="
//                   absolute w-full max-w-xl
//                   rounded-[28px]
//                   bg-white/80 backdrop-blur-xl
//                   border border-slate-200
//                   shadow-[0_30px_80px_rgba(15,23,42,0.18)]
//                   p-10
//                 "
//                 style={{ zIndex: 10 - Math.abs(offset) }}
//               >
//                 <div className="text-indigo-500 text-5xl font-serif mb-6">“</div>

//                 <p className="text-[20px] leading-relaxed text-slate-900">
//                   {t.text}
//                 </p>

//                 <div className="mt-8 pt-6 border-t border-slate-200 flex items-center gap-4">
//                   <div className="h-11 w-11 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-lg">
//                     <User size={16} />
//                   </div>
//                   <div>
//                     <p className="font-semibold text-slate-900">{t.name}</p>
//                     <p className="text-sm text-slate-600">{t.role}</p>
//                   </div>
//                 </div>
//               </motion.div>
//             );
//           })}

//           {/* Left Arrow */}
//           <button
//             onClick={prev}
//             className="absolute left-0 md:-left-16 h-12 w-12 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center hover:scale-110 transition"
//           >
//             <ChevronLeft size={20} />
//           </button>

//           {/* Right Arrow */}
//           <button
//             onClick={next}
//             className="absolute right-0 md:-right-16 h-12 w-12 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center hover:scale-110 transition"
//           >
//             <ChevronRight size={20} />
//           </button>

//         </div>

//         {/* Dots */}
//         <div className="flex justify-center gap-3 mt-14">
//           {testimonials.map((_, i) => (
//             <button
//               key={i}
//               onClick={() => setIndex(i)}
//               className={`h-2.5 w-2.5 rounded-full transition-all ${
//                 i === index
//                   ? "bg-indigo-600 w-6"
//                   : "bg-slate-300 hover:bg-slate-400"
//               }`}
//             />
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// }














// import { motion } from "framer-motion";
// import { useState, useRef } from "react";
// import { User, ChevronLeft, ChevronRight } from "lucide-react";

// const testimonials = [
//   {
//     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth.",
//     name: "Ayush Mangal Gupta",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Highly efficient and remarkably intuitive. The intelligent scheduling ensures nothing ever falls through the cracks.",
//     name: "Vasu Sangal",
//     role: "Lawyer · District Court",
//   },
//   {
//     text: "The team collaboration features are outstanding. Case sharing and task updates feel effortless and precise.",
//     name: "Ajay Kumar",
//     role: "Lawyer · Supreme Court",
//   },
//   {
//     text: "The organized file management saves me hours every week. It lets me focus entirely on my clients.",
//     name: "Krishnam Soni",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Cause list and event tracking are extremely reliable. Every hearing and deadline stays clear.",
//     name: "Indresh Goswami",
//     role: "Lawyer · Supreme Court",
//   },
// ];

// export default function Testimonials() {
//   const [index, setIndex] = useState(0);
//   const isAnimating = useRef(false);

//   const next = () => {
//     if (isAnimating.current) return;
//     isAnimating.current = true;

//     setIndex((prev) =>
//       prev === testimonials.length - 1 ? 0 : prev + 1
//     );

//     setTimeout(() => {
//       isAnimating.current = false;
//     }, 600); // match animation duration
//   };

//   const prev = () => {
//     if (isAnimating.current) return;
//     isAnimating.current = true;

//     setIndex((prev) =>
//       prev === 0 ? testimonials.length - 1 : prev - 1
//     );

//     setTimeout(() => {
//       isAnimating.current = false;
//     }, 600);
//   };

//   return (
//     <section className="relative py-32 bg-gradient-to-b from-[#F6F8FC] via-white to-[#F9FAFF] overflow-hidden">

//       {/* Ambient glow */}
//       <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-indigo-300/20 rounded-full blur-[160px]" />
//       <div className="absolute bottom-0 -right-40 w-[500px] h-[500px] bg-amber-300/20 rounded-full blur-[160px]" />

//       <div className="relative z-10 max-w-6xl mx-auto px-6">

//         {/* Header */}
//         <div className="text-center mb-20">
//           <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#0B1220]">
//             Trusted by Legal Professionals
//           </h2>
//           <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">
//             Real feedback from lawyers using Jurident in their daily practice.
//           </p>
//         </div>

//         {/* Cards */}
//         <div className="relative flex justify-center items-center min-h-[360px]">

//           {testimonials.map((t, i) => {
//             const offset = i - index;
//             if (Math.abs(offset) > 2) return null;

//             return (
//               <motion.div
//                 key={i}
//                 animate={{
//                   scale: offset === 0 ? 1 : 0.92,
//                   opacity: offset === 0 ? 1 : 0.25,
//                   x: offset * 260,
//                 }}
//                 transition={{ duration: 0.6, ease: "easeOut" }}
//                 className="
//                   absolute w-full max-w-xl
//                   rounded-[28px]
//                   bg-white/80 backdrop-blur-xl
//                   border border-slate-200
//                   shadow-[0_30px_80px_rgba(15,23,42,0.18)]
//                   p-10
//                 "
//                 style={{ zIndex: 10 - Math.abs(offset) }}
//               >
//                 <div className="text-indigo-500 text-5xl font-serif mb-6">“</div>

//                 <p className="text-[20px] leading-relaxed text-slate-900">
//                   {t.text}
//                 </p>

//                 <div className="mt-8 pt-6 border-t border-slate-200 flex items-center gap-4">
//                   <div className="h-11 w-11 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-lg">
//                     <User size={16} />
//                   </div>
//                   <div>
//                     <p className="font-semibold text-slate-900">{t.name}</p>
//                     <p className="text-sm text-slate-600">{t.role}</p>
//                   </div>
//                 </div>
//               </motion.div>
//             );
//           })}

//           {/* Left Arrow */}
//           <button
//             onClick={prev}
//             className="absolute left-0 md:-left-16 h-12 w-12 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center hover:scale-110 transition"
//           >
//             <ChevronLeft size={20} />
//           </button>

//           {/* Right Arrow */}
//           <button
//             onClick={next}
//             className="absolute right-0 md:-right-16 h-12 w-12 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center hover:scale-110 transition"
//           >
//             <ChevronRight size={20} />
//           </button>

//         </div>

//         {/* Dots */}
//         <div className="flex justify-center gap-3 mt-14">
//           {testimonials.map((_, i) => (
//             <button
//               key={i}
//               onClick={() => setIndex(i)}
//               className={`h-2.5 w-2.5 rounded-full transition-all ${
//                 i === index
//                   ? "bg-indigo-600 w-6"
//                   : "bg-slate-300 hover:bg-slate-400"
//               }`}
//             />
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// }















// import { motion } from "framer-motion";
// import { useState } from "react";
// import { User } from "lucide-react";
// import { ChevronLeft, ChevronRight } from "lucide-react";

// const testimonials = [
//   {
//     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth.",
//     name: "Ayush Mangal Gupta",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Highly efficient and remarkably intuitive. The intelligent scheduling ensures nothing ever falls through the cracks.",
//     name: "Vasu Sangal",
//     role: "Lawyer · District Court",
//   },
//   {
//     text: "The team collaboration features are outstanding. Case sharing and task updates feel effortless and precise.",
//     name: "Ajay Kumar",
//     role: "Lawyer · Supreme Court",
//   },
//   {
//     text: "The organized file management saves me hours every week. It lets me focus entirely on my clients.",
//     name: "Krishnam Soni",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Cause list and event tracking are extremely reliable. Every hearing and deadline stays clear.",
//     name: "Indresh Goswami",
//     role: "Lawyer · Supreme Court",
//   },
// ];

// export default function Testimonials() {
//   const [index, setIndex] = useState(0);

//   // 🔹 Fixed — no wrap around
//   const next = () => {
//     setIndex((prev) =>
//       prev < testimonials.length - 1 ? prev + 1 : prev
//     );
//   };

//   const prev = () => {
//     setIndex((prev) =>
//       prev > 0 ? prev - 1 : prev
//     );
//   };

//   return (
//     <section className="relative py-32 bg-gradient-to-b from-[#F6F8FC] via-white to-[#F9FAFF] overflow-hidden">

//       {/* Ambient glow */}
//       <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-indigo-300/20 rounded-full blur-[160px]" />
//       <div className="absolute bottom-0 -right-40 w-[500px] h-[500px] bg-amber-300/20 rounded-full blur-[160px]" />

//       <div className="relative z-10 max-w-6xl mx-auto px-6">

//         {/* Header */}
//         <div className="text-center mb-20">
//           <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#0B1220]">
//             Trusted by Legal Professionals
//           </h2>
//           <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">
//             Real feedback from lawyers using Jurident in their daily practice.
//           </p>
//         </div>

//         {/* Cards */}
//         <div className="relative flex justify-center items-center min-h-[360px]">

//           {testimonials.map((t, i) => {
//             const offset = i - index;
//             if (Math.abs(offset) > 2) return null;

//             return (
//               <motion.div
//                 key={i}
//                 animate={{
//                   scale: offset === 0 ? 1 : 0.92,
//                   opacity: offset === 0 ? 1 : 0.25,
//                   x: offset * 260,
//                 }}
//                 transition={{ duration: 0.6, ease: "easeOut" }}
//                 className="
//                   absolute w-full max-w-xl
//                   rounded-[28px]
//                   bg-white/80 backdrop-blur-xl
//                   border border-slate-200
//                   shadow-[0_30px_80px_rgba(15,23,42,0.18)]
//                   p-10
//                 "
//                 style={{ zIndex: 10 - Math.abs(offset) }}
//               >
//                 <div className="text-indigo-500 text-5xl font-serif mb-6">“</div>

//                 <p className="text-[20px] leading-relaxed text-slate-900">
//                   {t.text}
//                 </p>

//                 <div className="mt-8 pt-6 border-t border-slate-200 flex items-center gap-4">
//                   <div className="h-11 w-11 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-lg">
//                     <User size={16} />
//                   </div>
//                   <div>
//                     <p className="font-semibold text-slate-900">{t.name}</p>
//                     <p className="text-sm text-slate-600">{t.role}</p>
//                   </div>
//                 </div>
//               </motion.div>
//             );
//           })}

//           {/* Left Arrow */}
//           <button
//             onClick={prev}
//             className="absolute left-0 md:-left-16 h-12 w-12 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center hover:scale-110 transition"
//           >
//             <ChevronLeft size={20} />
//           </button>

//           {/* Right Arrow */}
//           <button
//             onClick={next}
//             className="absolute right-0 md:-right-16 h-12 w-12 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center hover:scale-110 transition"
//           >
//             <ChevronRight size={20} />
//           </button>

//         </div>

//         {/* Dots */}
//         <div className="flex justify-center gap-3 mt-14">
//           {testimonials.map((_, i) => (
//             <button
//               key={i}
//               onClick={() => setIndex(i)}
//               className={`h-2.5 w-2.5 rounded-full transition-all ${
//                 i === index
//                   ? "bg-indigo-600 w-6"
//                   : "bg-slate-300 hover:bg-slate-400"
//               }`}
//             />
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// }
















// import { motion } from "framer-motion";
// import { useState } from "react";
// import { User } from "lucide-react";
// import { ChevronLeft, ChevronRight } from "lucide-react";

// const testimonials = [
//   {
//     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth.",
//     name: "Ayush Mangal Gupta",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Highly efficient and remarkably intuitive. The intelligent scheduling ensures nothing ever falls through the cracks.",
//     name: "Vasu Sangal",
//     role: "Lawyer · District Court",
//   },
//   {
//     text: "The team collaboration features are outstanding. Case sharing and task updates feel effortless and precise.",
//     name: "Ajay Kumar",
//     role: "Lawyer · Supreme Court",
//   },
//   {
//     text: "The organized file management saves me hours every week. It lets me focus entirely on my clients.",
//     name: "Krishnam Soni",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Cause list and event tracking are extremely reliable. Every hearing and deadline stays clear.",
//     name: "Indresh Goswami",
//     role: "Lawyer · Supreme Court",
//   },
// ];

// export default function Testimonials() {
//   const [index, setIndex] = useState(0);

//   const next = () => {
//     setIndex((prev) =>
//       prev < testimonials.length - 1 ? prev + 1 : prev
//     );
//   };

//   const prev = () => {
//     setIndex((prev) =>
//       prev > 0 ? prev - 1 : prev
//     );
//   };

//   return (
//     <section className="relative py-32 bg-gradient-to-b from-[#F6F8FC] via-white to-[#F9FAFF] overflow-hidden">

//       <div className="relative z-10 max-w-6xl mx-auto px-6">

//         {/* Header */}
//         <div className="text-center mb-20">
//           <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#0B1220]">
//             Trusted by Legal Professionals
//           </h2>
//           <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">
//             Real feedback from lawyers using Jurident in their daily practice.
//           </p>
//         </div>

//         {/* Cards */}
//         <div className="relative flex justify-center items-center min-h-[360px]">

//           {testimonials.map((t, i) => {
//             const offset = i - index;
//             if (Math.abs(offset) > 2) return null;

//             return (
//               <motion.div
//                 key={i}
//                 animate={{
//                   scale: offset === 0 ? 1 : 0.92,
//                   opacity: offset === 0 ? 1 : 0.25,
//                   x: offset * 260,
//                 }}
//                 transition={{ duration: 0.6, ease: "easeOut" }}
//                 className="
//                   absolute w-full max-w-xl
//                   rounded-[28px]
//                   bg-white/80 backdrop-blur-xl
//                   border border-slate-200
//                   shadow-[0_30px_80px_rgba(15,23,42,0.18)]
//                   p-10
//                 "
//                 style={{ zIndex: 10 - Math.abs(offset) }}
//               >
//                 <div className="text-indigo-500 text-5xl font-serif mb-6">“</div>

//                 <p className="text-[20px] leading-relaxed text-slate-900">
//                   {t.text}
//                 </p>

//                 <div className="mt-8 pt-6 border-t border-slate-200 flex items-center gap-4">
//                   <div className="h-11 w-11 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-lg">
//                     <User size={16} />
//                   </div>
//                   <div>
//                     <p className="font-semibold text-slate-900">{t.name}</p>
//                     <p className="text-sm text-slate-600">{t.role}</p>
//                   </div>
//                 </div>
//               </motion.div>
//             );
//           })}

//           {/* Left Arrow */}
//           <button
//             onClick={prev}
//             className="absolute left-0 md:-left-16 h-12 w-12 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center hover:scale-110 transition z-50 pointer-events-auto"
//           >
//             <ChevronLeft size={20} />
//           </button>

//           {/* Right Arrow */}
//           <button
//             onClick={next}
//             className="absolute right-0 md:-right-16 h-12 w-12 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center hover:scale-110 transition z-50 pointer-events-auto"
//           >
//             <ChevronRight size={20} />
//           </button>

//         </div>

//         {/* Dots */}
//         <div className="flex justify-center gap-3 mt-14">
//           {testimonials.map((_, i) => (
//             <button
//               key={i}
//               onClick={() => setIndex(i)}
//               className={`h-2.5 w-2.5 rounded-full transition-all ${
//                 i === index
//                   ? "bg-indigo-600 w-6"
//                   : "bg-slate-300 hover:bg-slate-400"
//               }`}
//             />
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// }


















//phone ok ok
import { motion } from "framer-motion";
import { useState } from "react";
import { User, ChevronLeft, ChevronRight } from "lucide-react";

const testimonials = [
  {
    text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth.",
    name: "Ayush Mangal Gupta",
    role: "Lawyer · High Court",
  },
  {
    text: "Highly efficient and remarkably intuitive. The intelligent scheduling ensures nothing ever falls through the cracks.",
    name: "Vasu Sangal",
    role: "Lawyer · District Court",
  },
  {
    text: "The team collaboration features are outstanding. Case sharing and task updates feel effortless and precise.",
    name: "Ajay Kumar",
    role: "Lawyer · Supreme Court",
  },
  {
    text: "The organized file management saves me hours every week. It lets me focus entirely on my clients.",
    name: "Krishnam Soni",
    role: "Lawyer · High Court",
  },
  {
    text: "Cause list and event tracking are extremely reliable. Every hearing and deadline stays clear.",
    name: "Indresh Goswami",
    role: "Lawyer · Supreme Court",
  },
];

export default function Testimonials() {
  const [index, setIndex] = useState(0);

  const next = () => {
    setIndex((prev) =>
      prev < testimonials.length - 1 ? prev + 1 : prev
    );
  };

  const prev = () => {
    setIndex((prev) =>
      prev > 0 ? prev - 1 : prev
    );
  };

  return (
    <section className="relative py-24 md:py-32 bg-gradient-to-b from-[#F6F8FC] via-white to-[#F8F7F4] overflow-hidden">
      <div className="relative z-10 max-w-6xl mx-auto px-5 md:px-6">

        {/* Header */}
        <div className="text-center mb-14 md:mb-20">
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight text-[#0B1220]">
            Trusted by Legal Professionals
          </h2>
          <p className="mt-4 text-base md:text-lg text-slate-600 max-w-2xl mx-auto">
            Real feedback from lawyers using Jurident in their daily practice.
          </p>
        </div>

        {/* Cards */}
        <div className="relative flex justify-center items-center min-h-[320px] md:min-h-[360px]">

          {/* MOBILE VIEW (Only Active Card) */}
          <div className="block md:hidden w-full">
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
              className="
                w-full
                rounded-[24px]
                bg-white/90 backdrop-blur-xl
                border border-slate-200
                shadow-[0_20px_50px_rgba(15,23,42,0.15)]
                p-6
              "
            >
              <div className="text-indigo-500 text-4xl font-serif mb-4">“</div>

              <p className="text-[16px] leading-relaxed text-slate-900">
                {testimonials[index].text}
              </p>

              <div className="mt-6 pt-5 border-t border-slate-200 flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-lg">
                  <User size={14} />
                </div>
                <div>
                  <p className="font-semibold text-slate-900 text-sm">
                    {testimonials[index].name}
                  </p>
                  <p className="text-xs text-slate-600">
                    {testimonials[index].role}
                  </p>
                </div>
              </div>
            </motion.div>
          </div>

          {/* DESKTOP VIEW (UNCHANGED) */}
          <div className="hidden md:flex justify-center items-center w-full">
            {testimonials.map((t, i) => {
              const offset = i - index;
              if (Math.abs(offset) > 2) return null;

              return (
                <motion.div
                  key={i}
                  animate={{
                    scale: offset === 0 ? 1 : 0.92,
                    opacity: offset === 0 ? 1 : 0.25,
                    x: offset * 260,
                  }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                  className="
                    absolute w-full max-w-xl
                    rounded-[28px]
                    bg-white/80 backdrop-blur-xl
                    border border-slate-200
                    shadow-[0_30px_80px_rgba(15,23,42,0.18)]
                    p-10
                  "
                  style={{ zIndex: 10 - Math.abs(offset) }}
                >
                  <div className="text-indigo-500 text-5xl font-serif mb-6">“</div>

                  <p className="text-[20px] leading-relaxed text-slate-900">
                    {t.text}
                  </p>

                  <div className="mt-8 pt-6 border-t border-slate-200 flex items-center gap-4">
                    <div className="h-11 w-11 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-lg">
                      <User size={16} />
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">{t.name}</p>
                      <p className="text-sm text-slate-600">{t.role}</p>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>

          {/* Arrows (Responsive Positioning) */}
          {/* <button
            onClick={prev}
            className="absolute left-2 md:left-0 md:-left-16 h-10 w-10 md:h-12 md:w-12 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center hover:scale-110 transition z-50"
          >
            <ChevronLeft size={18} />
          </button>

          <button
            onClick={next}
            className="absolute right-2 md:right-0 md:-right-16 h-10 w-10 md:h-12 md:w-12 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center hover:scale-110 transition z-50"
          >
            <ChevronRight size={18} />
          </button> */}
          {/* Arrows */}
<button
  onClick={prev}
  className="
    absolute left-[-10px] md:left-0 md:-left-16
    top-1/2 -translate-y-1/2
    h-9 w-9 md:h-12 md:w-12
    rounded-full bg-white shadow-lg border border-slate-200
    flex items-center justify-center
    hover:scale-110 transition z-50
  "
>
  <ChevronLeft size={18} />
</button>

<button
  onClick={next}
  className="
    absolute right-[-10px] md:right-0 md:-right-16
    top-1/2 -translate-y-1/2
    h-9 w-9 md:h-12 md:w-12
    rounded-full bg-white shadow-lg border border-slate-200
    flex items-center justify-center
    hover:scale-110 transition z-50
  "
>
  <ChevronRight size={18} />
</button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-3 mt-10 md:mt-14">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              className={`h-2.5 w-2.5 rounded-full transition-all ${
                i === index
                  ? "bg-indigo-600 w-6"
                  : "bg-slate-300 hover:bg-slate-400"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
















// import { motion } from "framer-motion";
// import { useState } from "react";
// import { User } from "lucide-react";
// import { ChevronLeft, ChevronRight } from "lucide-react";

// const testimonials = [
//   {
//     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth.",
//     name: "Ayush Mangal Gupta",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Highly efficient and remarkably intuitive. The intelligent scheduling ensures nothing ever falls through the cracks.",
//     name: "Vasu Sangal",
//     role: "Lawyer · District Court",
//   },
//   {
//     text: "The team collaboration features are outstanding. Case sharing and task updates feel effortless and precise.",
//     name: "Ajay Kumar",
//     role: "Lawyer · Supreme Court",
//   },
//   {
//     text: "The organized file management saves me hours every week. It lets me focus entirely on my clients.",
//     name: "Krishnam Soni",
//     role: "Lawyer · High Court",
//   },
//   {
//     text: "Cause list and event tracking are extremely reliable. Every hearing and deadline stays clear.",
//     name: "Indresh Goswami",
//     role: "Lawyer · Supreme Court",
//   },
// ];

// export default function Testimonials() {
//   const [index, setIndex] = useState(0);

//   const next = () => {
//     setIndex((prev) =>
//       prev < testimonials.length - 1 ? prev + 1 : prev
//     );
//   };

//   const prev = () => {
//     setIndex((prev) =>
//       prev > 0 ? prev - 1 : prev
//     );
//   };

//   return (
//    <section className="relative py-32 bg-[radial-gradient(circle_at_top,#FDF6EC_0%,#F6F8FF_45%,#FFFFFF_100%)] overflow-hidden">
//       <div className="relative z-10 max-w-6xl mx-auto px-6">

//         {/* Header */}
//         <div className="text-center mb-20">
//           <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#0B1220]">
//             Trusted by Legal Professionals
//           </h2>
//           <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">
//             Real feedback from lawyers using Jurident in their daily practice.
//           </p>
//         </div>

//         {/* Cards */}
//         <div className="relative flex justify-center items-center min-h-[360px]">
//           {testimonials.map((t, i) => {
//             const offset = i - index;
//             if (Math.abs(offset) > 2) return null;

//             return (
//               <motion.div
//                 key={i}
//                 animate={{
//                   scale: offset === 0 ? 1 : 0.92,
//                   opacity: offset === 0 ? 1 : 0.25,
//                   x: offset * 260,
//                 }}
//                 transition={{ duration: 0.6, ease: "easeOut" }}
//                 className="
//                   absolute w-full max-w-xl
//                   rounded-[28px]
//                   bg-white/80 backdrop-blur-xl
//                   border border-slate-200
//                   shadow-[0_30px_80px_rgba(15,23,42,0.18)]
//                   p-10
//                 "
//                 style={{ zIndex: 10 - Math.abs(offset) }}
//               >
//                 <div className="text-indigo-500 text-5xl font-serif mb-6">“</div>

//                 <p className="text-[20px] leading-relaxed text-slate-900">
//                   {t.text}
//                 </p>

//                 <div className="mt-8 pt-6 border-t border-slate-200 flex items-center gap-4">
//                   <div className="h-11 w-11 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center text-white shadow-lg">
//                     <User size={16} />
//                   </div>
//                   <div>
//                     <p className="font-semibold text-slate-900">{t.name}</p>
//                     <p className="text-sm text-slate-600">{t.role}</p>
//                   </div>
//                 </div>
//               </motion.div>
//             );
//           })}

//           {/* Arrows */}
//           <button
//             onClick={prev}
//             className="absolute left-0 md:-left-16 h-12 w-12 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center hover:scale-110 transition z-50"
//           >
//             <ChevronLeft size={20} />
//           </button>

//           <button
//             onClick={next}
//             className="absolute right-0 md:-right-16 h-12 w-12 rounded-full bg-white shadow-lg border border-slate-200 flex items-center justify-center hover:scale-110 transition z-50"
//           >
//             <ChevronRight size={20} />
//           </button>
//         </div>

//         {/* Dots */}
//         <div className="flex justify-center gap-3 mt-14">
//           {testimonials.map((_, i) => (
//             <button
//               key={i}
//               onClick={() => setIndex(i)}
//               className={`h-2.5 w-2.5 rounded-full transition-all ${
//                 i === index
//                   ? "bg-indigo-600 w-6"
//                   : "bg-slate-300 hover:bg-slate-400"
//               }`}
//             />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }
